"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTIFY_FRONT_HAND_RIGHT = exports.TEXTIFY_BACK = exports.TEXTIFY_FRONT = exports.BILAN_TMPL = exports.PHARMACY_COMPLIANCE = exports.PHARMACY_COMPLIANCE_REMARQUE = exports.PHARMACY_COMPLIANCE_CONFORMITE = exports.TEMPERATURE_ZONE_OPTS = exports.OXY_DEBIT_UNIT_OPTS = exports.PALEURS_OPTS = exports.EVDA_OPTS = exports.AVPU_OPTS = exports.PUPILLES_BILATERAL_OPTS = exports.PUPILLES_OPTS = exports.SCORE_SEDATION_OPTS = exports.GLASGOW_M_SSO_SMP_OPTS = exports.GLASGOW_M_OPTS = exports.GLA_M_OPTS = exports.GLA_V_SSO_SMP_OPTS = exports.GLA_V_OPTS = exports.GLASGOW_Y_SSO_SMP_OPTS = exports.GLASGOW_Y_OPTS = exports.GLA_Y_OPTS = exports.APGAR_COLORATION_OPTS = exports.APGAR_REACTIVITE_OPTS = exports.APGAR_TONUS_OPTS = exports.APGAR_FC_OPTS = exports.APGAR_FR_OPTS = exports.MALINAS_PERTE_EAUX_OPTS = exports.MALINAS_TRAVAIL_OPTS = exports.COTATION_MEDICALE_NOTATION_REDACTION = exports.COTATION_MEDICALE_NOTATION_COMPORTEMENT = exports.COTATION_MEDICALE_NOTATION_GASSPPE = exports.COTATION_MEDICALE_NOTATION_PISU = exports.COTATION_MEDICALE_INDICATEURS = exports.COTATION_MEDICALE_PISU_GASSPPE = exports.COTATION_MEDICALE_PATHOLOGIE = exports.COTATION_MEDICALE_CCMU = exports.SMUR_MISSION = exports.PRIORISATION = exports.AGE_UNITS_OPTIONS = exports.CIVILITY_OPTIONS = exports.SEX_OPTIONS = exports.PDF_COTATION_OPTIONS = exports.PDF_SALARIE_OPTIONS = exports.PDF_ADRESSE_OPTIONS = exports.GLYCEMIE_UNITS = exports.ROUTE_OF_ADMINISTRATION = exports.MEDIC_UNITS = exports.SCOPE_PUY_DU_FOU = void 0;
exports.UUID_OPTIONS = exports.PRESCRIPTION_STATE_LABEL = exports.solutesSdis38 = exports.solutes = exports.MANNEQUIN_VISIBLE_COLORS = exports.MANNEQUIN_COLORS = exports.TEXTIFY_FRONT_HEAD = exports.TEXTIFY_BACK_FOOT_LEFT = exports.TEXTIFY_BACK_FOOT_RIGHT = exports.TEXTIFY_FRONT_FOOT_LEFT = exports.TEXTIFY_FRONT_FOOT_RIGHT = exports.TEXTIFY_BACK_HAND_LEFT = exports.TEXTIFY_BACK_HAND_RIGHT = exports.TEXTIFY_FRONT_HAND_LEFT = void 0;
// organization_id 38: Puy du fou
// organization_id 1: Tildev
exports.SCOPE_PUY_DU_FOU = [1, 38];
exports.MEDIC_UNITS = new Map([
    [1, 'mg'],
    [2, 'g'],
    [3, 'mL'],
    [4, 'L/min'],
    [5, 'Dose(s)'],
    [6, 'Sachet(s)'],
    [7, 'Comprimé(s)'],
    [8, 'Ampoule(s)'],
    [9, 'Suppositoire(s)'], // TODO: à retirer ?
    [10, 'NA'],
    [11, 'mg/h'],
    [12, 'gamma/kg/min'],
    [13, 'Unité Internationales (UI)'],
    [14, 'μg/h'],
    [15, 'UI/h'],
]);
exports.ROUTE_OF_ADMINISTRATION = new Map([
    [0, 'Voie NR'],
    [1, 'Inhalé'],
    [2, 'Intramusculaire'],
    [3, 'Intranasal'],
    [4, 'Intrarectal'],
    [5, 'IV flash'],
    [6, 'IV lente'],
    [7, 'Per cutanée'],
    [8, 'Per OS'],
    [9, 'PSE'],
    [10, 'Sous-cutané'],
    [11, 'Sublinguale'],
    [12, 'Intra osseux'],
    [13, 'VV centrale'],
    [14, 'VV périphérique'],
]);
exports.GLYCEMIE_UNITS = new Map([
    [0, 'g/L'],
    [1, 'mmol/L'],
    [2, 'mg/dL'],
]);
exports.PDF_ADRESSE_OPTIONS = [
    { value: 1, label: 'Cinéscénie > Cavalerie' },
    { value: 2, label: 'Cinéscénie > Pêcherie' },
    { value: 3, label: 'Cinéscénie > Château' },
    { value: 4, label: 'Cinéscénie > Tribunes' },
    { value: 5, label: 'Cinéscénie > Déambulatoire' },
    { value: 6, label: 'Cinéscénie > Escalator' },
    { value: 7, label: 'Cinéscénie > Allée des spectateurs' },
    { value: 8, label: 'Cinéscénie > Village Château' },
    { value: 9, label: 'Cinéscénie > Village Ile' },
    { value: 10, label: 'Cinéscénie > Village Allée Romaine' },
    { value: 11, label: 'Cinéscénie > Village Pêcherie' },
    { value: 12, label: 'Cinéscénie > Village des Ouches' },
    { value: 13, label: 'Cinéscénie > Remparts' },
    { value: 14, label: 'Cinéscénie > Avant-scène' },
    { value: 15, label: 'Cinéscénie > Arrière-scène' },
    { value: 16, label: 'Cinéscénie > Donjon/scène secret de la Lance' },
    { value: 17, label: 'Cinéscénie > Etang principal' },
    { value: 18, label: 'Cinéscénie > Etang secondaire' },
    { value: 19, label: 'Cinéscénie > Allée de défilement' },
    { value: 20, label: 'Cinéscénie > Déambulatoire' },
    { value: 21, label: 'Cinéscénie > Infirmerie cinescénie' },
    { value: 22, label: 'Grand Parc > Spectacles > Stadium Gallo-Romain' },
    { value: 23, label: 'Grand Parc > Spectacles > Vikings' },
    { value: 24, label: 'Grand Parc > Spectacles > Chevaliers de la table ronde' },
    { value: 25, label: 'Grand Parc > Spectacles > Bal des oiseaux fantômes' },
    { value: 26, label: 'Grand Parc > Spectacles > Carillon' },
    { value: 27, label: 'Grand Parc > Spectacles > Mystère de la perouze' },
    { value: 28, label: 'Grand Parc > Spectacles > Premier royaume' },
    { value: 29, label: 'Grand Parc > Spectacles > Amoureux de verdun' },
    { value: 30, label: 'Grand Parc > Spectacles > Les orgues de feu/les grandes eaux' },
    { value: 31, label: 'Grand Parc > Spectacles > Dernier panache' },
    { value: 32, label: 'Grand Parc > Spectacles > Ballet des sapeurs' },
    { value: 33, label: 'Grand Parc > Spectacles > Monde imaginaire de la fontaine' },
    { value: 34, label: 'Grand Parc > Spectacles > Repaire aux enfants' },
    { value: 35, label: 'Grand Parc > Spectacles > Jets sauteurs' },
    { value: 36, label: 'Grand Parc > Spectacles > Secret de la lance' },
    { value: 37, label: 'Grand Parc > Spectacles > Renaissance du Chateau' },
    { value: 38, label: 'Grand Parc > Spectacles > Mousquetaires de richelieu' },
    { value: 39, label: 'Grand Parc > Hotels > Citadelle' },
    { value: 40, label: 'Grand Parc > Hotels > Villa Gallo-Romaine' },
    { value: 41, label: "Grand Parc > Hotels > Camp du draps d'or" },
    { value: 42, label: 'Grand Parc > Hotels > Iles de Clovis' },
    { value: 43, label: "Grand Parc > Hotels > Logis de l'Esclure" },
    { value: 44, label: 'Grand Parc > Services > Infirmerie' },
    { value: 45, label: 'Grand Parc > Services > Cavalerie' },
    { value: 46, label: 'Grand Parc > Services > Déchetterie' },
    { value: 47, label: 'Grand Parc > Services > Manoir' },
    { value: 48, label: 'Grand Parc > Services > Chenil' },
    { value: 49, label: 'Grand Parc > Services > Pension canine' },
    { value: 50, label: 'Grand Parc > Services > Fauconnerie' },
    { value: 51, label: 'Grand Parc > Services > Espace Vert' },
    { value: 52, label: 'Grand Parc > Services > Régie' },
    { value: 53, label: 'Grand Parc > Services > Brigand' },
    { value: 54, label: 'Grand Parc > Services > Costumerie' },
    { value: 55, label: 'Grand Parc > Services > PDFA' },
    { value: 56, label: 'Grand Parc > Services > Village de la grange' },
    { value: 57, label: 'Grand Parc > Villages > Bourg 1900' },
    { value: 58, label: 'Grand Parc > Villages > Village XVIIIème' },
    { value: 59, label: 'Grand Parc > Villages > Cité médiévale' },
    { value: 60, label: "Grand Parc > Villages > Fort de l'an mil" },
    { value: 61, label: 'Grand Parc > Restaurants > Orangerie' },
    { value: 62, label: 'Grand Parc > Restaurants > Café de la madelon' },
    { value: 63, label: 'Grand Parc > Restaurants > Bistrot' },
    { value: 64, label: 'Grand Parc > Restaurants > Echansonnerie' },
    { value: 65, label: 'Grand Parc > Restaurants > Gargoulette' },
    { value: 66, label: 'Grand Parc > Restaurants > Garde-manger' },
    { value: 67, label: 'Grand Parc > Restaurants > Mijoterie du Roi Henry' },
    { value: 68, label: "Grand Parc > Restaurants > Queue de l'étang" },
    { value: 69, label: 'Grand Parc > Restaurants > Relais de Poste' },
    { value: 70, label: 'Grand Parc > Restaurants > Etape' },
    { value: 71, label: 'Grand Parc > Restaurants > Rotissoire' },
    { value: 72, label: 'Grand Parc > Restaurants > Maison du Préfou' },
    { value: 73, label: 'Grand Parc > Restaurants > Auberge' },
    { value: 74, label: 'Grand Parc > Restaurants > Ventre faim' },
    { value: 75, label: 'Grand Parc > Restaurants > Taverne' },
    { value: 76, label: 'Grand Parc > Restaurants > Estaminet' },
    { value: 77, label: "Grand Parc > Restaurants > Fort de l'an mil" },
    { value: 78, label: 'Grand Parc > Restaurants > Popina' },
    { value: 79, label: 'Grand Parc > Entrées > Entrées Bourg 1900' },
    { value: 80, label: 'Grand Parc > Entrées > Contrôle sécurité Bourg' },
    { value: 81, label: 'Grand Parc > Entrées > Porte du temps' },
    { value: 82, label: 'Grand Parc > Entrées > Entrées cité nocturne' },
    { value: 83, label: 'Grand Parc > Entrées > Ile' },
    { value: 84, label: 'Grand Parc > Entrées > Avant-scène' },
    { value: 85, label: 'Grand Parc > Entrées > Arrière-scène' },
    { value: 86, label: 'Grand Parc > Entrées > Tribunes' },
    { value: 87, label: 'Grand Parc > Entrées > Allée des spectateurs' },
    { value: 88, label: 'Grand Parc > Entrées > Déambulatoire' },
    { value: 89, label: 'Grand Parc > Entrées > Escalator' },
    { value: 90, label: 'Grand Parc > Autres > Vallée fleurie' },
    { value: 91, label: 'Grand Parc > Autres > Allée des volières' },
    { value: 92, label: 'Grand Parc > Autres > Toilettes' },
    { value: 93, label: 'Grand Parc > Autres > Allée du parc' },
    { value: 94, label: 'Grand Parc > Parkings > A' },
    { value: 95, label: 'Grand Parc > Parkings > B' },
    { value: 96, label: 'Grand Parc > Parkings > C' },
    { value: 97, label: 'Grand Parc > Parkings > D' },
    { value: 98, label: 'Grand Parc > Parkings > E' },
    { value: 99, label: 'Grand Parc > Parkings > F' },
    { value: 100, label: 'Grand Parc > Parkings > Camping-Car' },
    { value: 101, label: 'Grand Parc > Parkings > PMR' },
    { value: 102, label: 'Grand Parc > Parkings > Pêcherie' },
    { value: 103, label: 'Grand Parc > Parkings > Menanterie' },
    { value: 104, label: 'Grand Parc > Parkings > Allée Romaine' },
    { value: 105, label: 'Grand Parc > Parkings > Viking' },
    { value: 106, label: 'Grand Parc > Parkings > Manoir' },
    { value: 107, label: 'Grand Parc > Parkings > Stadium' },
];
exports.PDF_SALARIE_OPTIONS = [
    { value: 1, label: 'Visiteur' },
    { value: 2, label: 'Stagiaire' },
    { value: 3, label: 'PDFA' },
    { value: 4, label: 'Bénévole: Services' },
    { value: 5, label: 'Bénévole: Pêcherie' },
    { value: 6, label: 'Bénévole: Château' },
    { value: 7, label: 'Bénévole: Calaverie' },
    { value: 8, label: 'Bénévole: Allée Romaine' },
    { value: 9, label: 'Bénévole: Ile' },
    { value: 10, label: 'Bénévole: Animalerie' },
    { value: 11, label: 'Bénévole: Néoptère' },
    { value: 12, label: 'Bénévole: Artificier' },
    { value: 13, label: 'Salarié: PDFResto' },
    { value: 14, label: 'Salarié: PDFCongrès' },
    { value: 15, label: 'Salarié: PDFI' },
    { value: 16, label: 'Salarié:s Manoir' },
    { value: 17, label: 'Salarié: Sécurité' },
    { value: 18, label: 'Salarié: Blanchisserie' },
    { value: 19, label: 'Salarié: Costumerie' },
    { value: 20, label: 'Salarié: GC' },
    { value: 21, label: 'Salarié: Bourg' },
    { value: 22, label: 'Salarié: Accueil' },
    { value: 23, label: 'Salarié: Photo' },
    { value: 24, label: 'Salarié: Coca' },
    { value: 25, label: 'Salarié: SDL' },
    { value: 26, label: 'Salarié: TDG' },
    { value: 27, label: 'Salarié: Stadium' },
    { value: 28, label: 'Salarié: Viking' },
    { value: 29, label: 'Salarié: Fauconnerie' },
    { value: 30, label: 'Salarié: Pension Canine' },
    { value: 31, label: 'Salarié: Cavalerie' },
    { value: 32, label: 'Salarié: Hotels' },
    { value: 33, label: 'Salarié: Animalerie' },
    { value: 34, label: 'Salarié: Régie' },
    { value: 35, label: 'Salarié: Jardinerie' },
    { value: 36, label: 'Salarié: Artisans' },
    { value: 37, label: 'Salarié: Informatique' },
    { value: 38, label: 'Salarié: Fauverie' },
    { value: 39, label: 'Salarié: Accessoiristes' },
];
exports.PDF_COTATION_OPTIONS = [
    { value: 1, label: 'Blessure légère' },
    { value: 2, label: 'Blessure grave' },
    { value: 3, label: 'Intervention annulée' },
    { value: 4, label: 'Autre' },
];
exports.SEX_OPTIONS = [
    { value: '1', label: 'Homme' },
    { value: '2', label: 'Femme' },
    { value: '3', label: 'Indéterminé' },
    { value: 1, label: 'Homme' },
    { value: 2, label: 'Femme' },
    { value: 3, label: 'Indéterminé' },
];
exports.CIVILITY_OPTIONS = [
    { value: 1, label: 'M' },
    { value: 2, label: 'Mme' },
];
exports.AGE_UNITS_OPTIONS = [
    { value: 1, label: 'Jours' },
    { value: 2, label: 'Mois' },
    { value: 3, label: 'Ans' },
];
exports.PRIORISATION = [
    { value: 1, label: 'Bilan blanc' },
    { value: 2, label: 'Bilan jaune' },
    { value: 3, label: 'Bilan rouge' },
];
exports.SMUR_MISSION = [
    { value: 1, label: 'primaire' },
    { value: 2, label: 'secondaire' },
    { value: 3, label: 'de renfort' },
];
exports.COTATION_MEDICALE_CCMU = {
    path: 'fiche_bilan.equipe.cotation_ccmu',
    data: [
        {
            value: 2,
            label: '1. État clinique jugé stable. Pas d’acte complémentaire diagnostique ou thérapeutique. Examen clinique simple.',
        },
        {
            value: 3,
            label: '2. État lésionnel et/ou pronostic fonctionnel stable. Décision d’acte complémentaire diagnostique (Prise de sang, Radiographie conventionnelle) ou thérapeutique (suture, réduction) à réaliser.',
        },
        {
            value: 4,
            label: '3. État lésionnel et/ou pronostic fonctionnel jugé pouvant s’aggraver aux urgences ou durant l’intervention, sans mise en jeu du pronostic vital.',
        },
        { value: 5, label: '4. Situation pathologique engageant le pronostic vital sans gestes de réanimation immédiat.' },
        {
            value: 6,
            label: '5. Pronostic vital engagé. Prise en charge comportant la pratique immédiate de manœuvres de réanimation',
        },
        {
            value: 7,
            label: 'D. Patient déjà décédé à l’arrivée du SMUR ou du service des urgences. Pas de réanimation entreprise.',
        },
    ],
};
exports.COTATION_MEDICALE_PATHOLOGIE = {
    path: 'fiche_bilan.equipe.cotation_sdis38_pathologie',
    data: [
        { value: 1, label: 'Accouchement inopiné' },
        { value: 2, label: 'Accouchement menace' },
        { value: 3, label: 'ACR' },
        { value: 4, label: 'Affection médicale non étiquetée' },
        { value: 5, label: 'Allergie' },
        { value: 6, label: 'Angoisse' },
        { value: 7, label: 'Asthme' },
        { value: 8, label: 'AVC' },
        { value: 9, label: 'Brûlure' },
        { value: 10, label: 'Choc septique' },
        { value: 11, label: 'Choc, autre' },
        { value: 12, label: 'Colique néphrétique suspectée' },
        { value: 13, label: 'Coma' },
        { value: 14, label: 'Convulsions' },
        { value: 15, label: "Coup de châleur d'exercice" },
        { value: 16, label: 'Détresse respiratoire' },
        { value: 17, label: 'Douleur médicale autre' },
        { value: 18, label: 'Douleur thoracique atypique' },
        { value: 19, label: 'Douleur thoracique typique' },
        { value: 20, label: 'Douleurs abdominales' },
        { value: 21, label: 'Douleurs rhumatologique' },
        { value: 22, label: 'Electrisé / Electrocuté' },
        { value: 23, label: 'Epuisement à la châleur' },
        { value: 24, label: 'Etat de mal épileptique' },
        { value: 25, label: 'Gynéco-obstétrique' },
        { value: 26, label: 'Hypoglycémie' },
        { value: 27, label: 'Hypothermie' },
        { value: 28, label: 'Impliqués' },
        { value: 29, label: 'Infarctus du myocarde' },
        { value: 30, label: 'Intoxication autre' },
        { value: 31, label: "Intoxication aux fumées d'incendie" },
        { value: 32, label: 'Intoxication CO' },
        { value: 33, label: 'Intoxication éthylique' },
        { value: 34, label: 'Intoxication médicamenteuse volontaire' },
        { value: 35, label: 'Malaise vagal' },
        { value: 36, label: 'OAP' },
        { value: 37, label: 'Plaie grave' },
        { value: 38, label: 'Plaie simple' },
        { value: 39, label: 'Psychiatrie' },
        { value: 40, label: 'Purpura fulminans' },
        { value: 41, label: 'Syndrôme méningé' },
        { value: 42, label: 'Traumatisme isolé' },
        { value: 43, label: 'Traumatismes multiples' },
        { value: 44, label: 'Troubles du rythme' },
    ],
};
exports.COTATION_MEDICALE_PISU_GASSPPE = [
    { value: 1, label: 'ACR' },
    { value: 2, label: 'Analgésie' },
    { value: 3, label: 'Antidotes NRBC' },
    { value: 4, label: 'Asthme' },
    { value: 5, label: 'Brûlures graves' },
    { value: 6, label: 'Choc anaphylactique' },
    { value: 7, label: "Coup de chaleur d'exercice" },
    { value: 8, label: 'Epuisement par la chaleur' },
    { value: 9, label: 'Hypoglycémie' },
    { value: 10, label: 'Intoxication CO' },
    { value: 11, label: 'Intoxication fumées incendie' },
    { value: 12, label: 'Nausées et vomissements' },
    { value: 13, label: 'Détresse respi type OAP' },
    { value: 14, label: 'Douleur thoracique non trauma' },
    { value: 15, label: 'Suspi purpura fulminans' },
    { value: 16, label: 'Trauma sévère' },
    { value: 17, label: 'Trouble conscience' },
    { value: 18, label: 'Pas d’indication de PISU' },
];
exports.COTATION_MEDICALE_INDICATEURS = {
    path: 'fiche_bilan.equipe.cotation_sdis38_indicateurs',
    data: [
        { value: 1, label: 'Echec TL' },
        { value: 2, label: 'Echec VVP adulte' },
        { value: 3, label: 'Echec VVP pédiatrique' },
        { value: 4, label: 'Refus Antalgiques' },
    ],
};
exports.COTATION_MEDICALE_NOTATION_PISU = {
    path: 'fiche_bilan.equipe.cotation_sdis38_notation_pisu',
    data: [
        { value: 1, label: 'Conforme avec actes' },
        { value: 2, label: 'Non conforme' },
        { value: 3, label: 'Non réalisé' },
    ],
};
exports.COTATION_MEDICALE_NOTATION_GASSPPE = {
    path: 'fiche_bilan.equipe.cotation_sdis38_notation_gassppe',
    data: [
        { value: 1, label: 'Conforme avec actes' },
        { value: 2, label: 'GASSPPE conforme sans acte (refus MOP)' },
        { value: 3, label: 'Non conforme' },
        { value: 4, label: 'Non réalisé' },
    ],
};
exports.COTATION_MEDICALE_NOTATION_COMPORTEMENT = {
    path: 'fiche_bilan.equipe.cotation_sdis38_notation_comportement',
    data: [
        { value: 1, label: 'Remarquable' },
        { value: 2, label: 'Sans objet / normal' },
        { value: 3, label: 'Insuffisant' },
    ],
};
exports.COTATION_MEDICALE_NOTATION_REDACTION = {
    path: 'fiche_bilan.equipe.cotation_sdis38_notation_redaction',
    data: [
        { value: 1, label: 'Remarquable' },
        { value: 2, label: 'Sans objet / normal' },
        { value: 3, label: 'Insuffisant' },
    ],
};
exports.MALINAS_TRAVAIL_OPTS = [
    { value: 1, label: '< 3h', kind: 'positive' },
    { value: 2, label: 'Entre 3h et 5h', kind: 'negative' },
    { value: 3, label: '> 5h', kind: 'negative' },
];
exports.MALINAS_PERTE_EAUX_OPTS = [
    { value: 1, label: 'Non', kind: 'positive' },
    { value: 2, label: '< 1h', kind: 'negative' },
    { value: 3, label: '> 1h', kind: 'negative' },
];
exports.APGAR_FR_OPTS = [
    { value: 1, label: '0' },
    { value: 2, label: 'Irréguliers' },
    { value: 3, label: 'Réguliers' },
];
exports.APGAR_FC_OPTS = [
    { value: 1, label: '0' },
    { value: 2, label: '< 100' },
    { value: 3, label: '> 100' },
];
exports.APGAR_TONUS_OPTS = [
    { value: 1, label: '0' },
    { value: 2, label: 'Léger tonus' },
    { value: 3, label: 'Bon tonus' },
];
exports.APGAR_REACTIVITE_OPTS = [
    { value: 1, label: '0' },
    { value: 2, label: 'Grimace / Léger mouvement' },
    { value: 3, label: 'Cri' },
];
exports.APGAR_COLORATION_OPTS = [
    { value: 1, label: 'Cyanose / Pâleur' },
    { value: 2, label: 'Extrémités cyanosées, corps rose' },
    { value: 3, label: 'Totalement rose' },
];
exports.GLA_Y_OPTS = [
    { value: 1, label: '1 - Aucune' },
    { value: 2, label: '2 - À la douleur' },
    { value: 3, label: '3 - Au bruit' },
    { value: 4, label: '4 - Spontanée' },
];
exports.GLASGOW_Y_OPTS = [
    { value: 1, label: '1 - Aucune' },
    { value: 2, label: '2 - À la douleur' },
    { value: 3, label: '3 - À la commande verbale' },
    { value: 4, label: '4 - Spontanée' },
];
exports.GLASGOW_Y_SSO_SMP_OPTS = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
];
exports.GLA_V_OPTS = [
    { value: 1, label: '1 - Aucune' },
    { value: 2, label: '2 - Incompréhensible' },
    { value: 3, label: '3 - Inappropriée' },
    { value: 4, label: '4 - Confuse' },
    { value: 5, label: '5 - Orientée' },
];
exports.GLA_V_SSO_SMP_OPTS = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
];
exports.GLA_M_OPTS = [
    { value: 1, label: '1 - Aucune' },
    { value: 2, label: '2 - Extension à la douleur' },
    { value: 3, label: '3 - Flexion à la douleur' },
    { value: 4, label: '4 - Évitement non adapté' },
    { value: 5, label: '5 - Adaptée à la douleur' },
    { value: 6, label: '6 - Obéit à la parole' },
];
exports.GLASGOW_M_OPTS = [
    { value: 1, label: '1 - Nulle' },
    { value: 2, label: '2 - Décérébration (MS extension, MI extension)' },
    { value: 3, label: '3 - Décortication (MS flexion, MI extension)' },
    { value: 4, label: '4 - Non orienté à la douleur' },
    { value: 5, label: '5 - Orienté à la douleur' },
    { value: 6, label: '6 - Obéit à un ordre' },
];
exports.GLASGOW_M_SSO_SMP_OPTS = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
];
exports.SCORE_SEDATION_OPTS = [
    { value: 1, label: '1 - Anxieux, agité' },
    { value: 2, label: '2 - Coopérant, orienté, calme' },
    { value: 3, label: '3 - Réponds aux ordres' },
    { value: 4, label: '4 - Endormi mais répond aux stimuli' },
    { value: 5, label: '5 - Endormi, réponses faibles' },
    { value: 6, label: '6 - Ne réponds pas' },
];
exports.PUPILLES_OPTS = [
    { value: 1, label: 'Asymétriques / Anisocorie', kind: 'negative' },
    { value: 2, label: 'Réactives', kind: 'positive' },
    { value: 3, label: 'Aréactives', kind: 'negative' },
    { value: 4, label: 'Mydriase bilatérale', kind: 'negative' },
    { value: 5, label: 'Pas de RPM', kind: 'negative' },
    { value: 6, label: 'Myosis', kind: 'negative' },
    { value: 7, label: 'Symétrique', kind: 'positive' },
];
exports.PUPILLES_BILATERAL_OPTS = [
    { value: 0, label: 'RAS', kind: 'positive' },
    { value: 1, label: 'Non réactive G', kind: 'negative' },
    { value: 2, label: 'Non réactive D', kind: 'negative' },
    { value: 3, label: 'Myosis (serrée) G', kind: 'negative' },
    { value: 4, label: 'Myosis (serrée) D', kind: 'negative' },
    { value: 5, label: 'Intermédiaire G', kind: 'positive' },
    { value: 6, label: 'Intermédiaire D', kind: 'positive' },
    { value: 7, label: 'Mydriase (dilatée) G', kind: 'negative' },
    { value: 8, label: 'Mydriase (dilatée) D', kind: 'negative' },
];
exports.AVPU_OPTS = [
    { value: 1, label: 'A - Consciente / Orientée', kind: 'positve' },
    { value: 2, label: 'V - Désorientée ou stimulation verbale nécessaire', kind: 'negative' },
    { value: 3, label: 'P - Stimulation à la douleur nécessaire', kind: 'negative' },
    { value: 4, label: 'U - Ne répond à aucune stimulation', kind: 'negative' },
];
exports.EVDA_OPTS = [
    { value: 1, label: 'E - Conscient / Alerte / Éveillée', kind: 'positve' },
    { value: 2, label: 'V - Réactive à la voix', kind: 'negative' },
    { value: 3, label: 'D - Réactive à la douleur', kind: 'negative' },
    { value: 4, label: 'A - Aréactive', kind: 'negative' },
];
exports.PALEURS_OPTS = [
    { value: 1, label: 'Peau/Muqueuse colorée', kind: 'positive' },
    { value: 2, label: 'Pâleurs conjonctives', kind: 'negative' },
    { value: 3, label: 'Pâleurs des muqueuses', kind: 'negative' },
    { value: 5, label: 'Pâleur cutanée', kind: 'negative' },
    { value: 4, label: 'Marbrures', kind: 'negative' },
];
exports.OXY_DEBIT_UNIT_OPTS = [
    { value: 1, label: 'L/min' },
    { value: 2, label: '% (FiO2)' },
];
exports.TEMPERATURE_ZONE_OPTS = [
    { value: 1, label: 'Axillaire non corrigée' },
    { value: 2, label: 'Axillaire corrigée' },
    { value: 3, label: 'Rectale' },
    { value: 4, label: 'Frontale' },
    { value: 5, label: 'Auriculaire' },
];
exports.PHARMACY_COMPLIANCE_CONFORMITE = [
    { value: 1, label: 'Conforme', kind: 'positive' },
    { value: 2, label: 'Non conforme', kind: 'negative' },
];
exports.PHARMACY_COMPLIANCE_REMARQUE = [
    { value: 3, label: 'Aucune remarque', kind: 'positive' },
    { value: 4, label: 'Remarque', kind: 'negative' },
];
exports.PHARMACY_COMPLIANCE = [...exports.PHARMACY_COMPLIANCE_CONFORMITE, ...exports.PHARMACY_COMPLIANCE_REMARQUE];
exports.BILAN_TMPL = Object.freeze({
    fiche_bilan: {
        bilan: {
            en_cours: 'new',
            simplifie: false,
        },
        equipe: {
            adresse: '',
            heure_arrivee_intervention: '',
            intervention_num: '',
            signature: '',
            temps_passe: '',
            vehicule: '',
            heure_fin_inter: null,
            cotation: 0,
            cotation_ccmu: null,
            cotation_puy_du_fou: null,
            evacuation: null,
            heure_arrivee_intervention_time: null,
            heure_arrivee_intervention_date: null,
            heure_fin_inter_time: null,
            heure_fin_inter_date: null,
            adresse_position: null,
            intervention_cloture: false,
            signature_iao: null,
            presence_medicale: 0,
            presence_medicale_autre: null,
            cotation_sdis38_pathologie: null,
            cotation_sdis38_pisu: [],
            cotation_sdis38_indicateurs: [],
            cotation_sdis38_notation_pisu: null,
            cotation_sdis38_notation_gassppe: null,
            cotation_sdis38_notation_comportement: null,
            cotation_sdis38_notation_redaction: null,
            cotation_sdis38_antalgie_evn_initial: null,
            cotation_sdis38_antalgie_evn_final: null,
            cotation_sdis38_smur_sur_place: false,
        },
        fiche: {
            acr: {
                date_arret_cardiaque: null,
                heure_racs: null,
                type_arret_cardiaque: null,
                cause_arret_cardique_medical: null,
                cause_arret_cardiaque_traumatique: null,
                temoins: null,
                temoin_rcp_immediate: null,
                temoin_mce: null,
                temoin_ventilation: null,
                pi_rcp: null,
                pi_type: null,
                pi_mce: null,
                pi_ventilation: null,
                dsa_present: null,
                dsa_utilise: null,
                dsa_nombre_chocs: null,
                rythme_initial: null,
                reanimation_smur: null,
                gasps: null,
                rigidite_cadaverique: null,
                ventilation: null,
                etco2_max_rcp: null,
                injection_type: null,
                injection_adrenaline_total: null,
                racs: null,
                cause_ac_asphyxie_input: null,
                cause_ac_intoxication_input: null,
                ventilation_type: null,
                ventilation_dispositif: null,
                devenir: null,
                pupilles: null,
                no_flow: null,
                low_flow: null,
                etco2_max_rcp_float: null,
                heure_racs_date: null,
                heure_racs_time: null,
            },
            circonstance: {
                circonstances: 'NR',
                commentaire: '',
                lieu: 'NR',
                provoque_par: '',
                qualite: '',
                region: '',
                severite: -1,
                temps: '',
                accident_travail: false,
                onset: null,
                temps_min: null,
                type_mission: null,
                situation_pathologies: null,
                situation_pathologies_str: null,
                situation: null,
                situation_sso: 'u',
                situation_amu: 'u',
                blesses: 'u',
                malaise: 'u',
                autres_missions: '',
                evenement_declencheur: '',
            },
            circulatoire: {
                fc: -1,
                arret_circulatoire: 'u',
                frappe: 'u',
                hemorragie: 'u',
                marbrures: 'u',
                paleur: 0,
                regulier: 'u',
                symetrique: 'u',
                tension_droite: '',
                tension_gauche: '',
                tension_reference: '',
                trc: 'u',
                pam: '',
                commentaire: '',
                smur_insuffisance_cardiaque: null,
                smur_troubles_rythme: 'u',
                nb_derivations: 0,
                per_critique: 'u',
                heure_realisation_ecg: null,
                absence_pouls_radial: 'u',
                recherche_hemorragie_interne: null,
                peau_temperature_anormale: 'u',
                trc_normale: 'u',
                extremites_froides: 'u',
                pouls_peripherique: 'u',
                pouls_central: 'u',
                controle_hemorragie: 'u',
                heure_realisation_ecg_date: null,
                heure_realisation_ecg_time: null,
                absence_pouls_radial_bilateral: null,
                peau_temperature: null,
                sensation_de_soif: 'u',
                hemorragie_detail: 0,
                localisation: null,
                examen_abdomen: null,
                examen_femurs: null,
                examen_bassin: null,
                douleur_thoracique: 'u',
                douleur_thoracique_qualite: null,
                douleur_thoracique_survenue: null,
                douleur_thoracique_provoque_par: null,
                temps_depuis_incident: null,
                froideur_cutanee: 'u',
                normale: 'u',
            },
            devenir: {
                deces: 'u',
                heure_deces: null,
                heure_declenchement: null,
                heure_arrivee_ch: null,
                nom_medecin: '',
                suggestion_ch: '0',
                evacuation: 0,
                renfort: 0,
                commentaire: '',
                heure_depart: null,
                heure_quitte_lieux: null,
                heure_sur_place: null,
                heure_appel: null,
                hopital_id: null,
                mode_transport: 0,
                heure_retour_parc: null,
                heure_arrivee_smur: null,
                mode_evacuation: 0,
                mode_evacuation_smur: false,
                mode_evacuation_infir: false,
                mode_evacuation_med: false,
                heure_fin_medicalisation: null,
                heure_depart_vers_intervention: null,
                heure_fin_medicalisation_date: null,
                heure_fin_medicalisation_time: null,
                heure_depart_vers_intervention_date: null,
                heure_depart_vers_intervention_time: null,
                heure_declenchement_time: null,
                heure_declenchement_date: null,
                heure_arrivee_ch_date: null,
                heure_arrivee_ch_time: null,
                heure_depart_ch_date: null,
                heure_depart_ch_time: null,
                heure_arrivee_smur_time: null,
                heure_arrivee_smur_date: null,
                heure_quitte_lieux_time: null,
                heure_quitte_lieux_date: null,
                heure_deces_date: null,
                heure_deces_time: null,
                heure_retour_parc_date: null,
                heure_retour_parc_time: null,
                heure_debut_evenement_time: null,
                heure_debut_evenement_date: null,
                heure_prise_en_charge_time: null,
                heure_prise_en_charge_date: null,
                heure_convergence_time: null,
                heure_convergence_date: null,
                heure_releve_time: null,
                heure_releve_date: null,
                doublure: null,
                mode_evacuation_suap: '',
            },
            douleur_thoracique: {
                debut_douleur: null,
                type_douleur: null,
                atcd_frcv: null,
                dyslipidemie_traitee: null,
                hta_traitee: null,
                type_diabete: null,
                diabete_traite: null,
                tabagisme_actif: null,
                avc_ait_type: null,
                traitements_en_cours: null,
                premier_ecg: null,
                diagnostic_presume: null,
                episode_similaire: 'u',
                deces: 'u',
                complications: null,
                debut_douleur_date: null,
                debut_douleur_time: null,
                premier_ecg_date: null,
                premier_ecg_time: null,
                interpretation_ecg: null,
                syndrome_coronarien: null,
                territoire: null,
                troubles_rythme: null,
            },
            geste: {
                medics: [],
                act: 'u',
                aerosol: 'u',
                aspiration: 'u',
                aspirationtra: 'u',
                attelle: 'u',
                autre: '',
                ceinture_pelvienne: 'u',
                chugapan: null,
                collier: 'u',
                compr_abdo: 'u',
                consentement: 0,
                ct6: 'u',
                defibrillation: 0,
                dega_ur: 'u',
                desinfection: 'u',
                ecg: 'u',
                echarpe: 'u',
                heimlich: 'u',
                inha: 0,
                insu: 0,
                intu: 'u',
                intubationtra: 'u',
                lunettes_o2: 'u',
                med_count: 0,
                mid: 'u',
                plandur: 'u',
                position: 0,
                protocole: 0,
                rcp: 'u',
                refus: 'u',
                relevage: 'u',
                ret_casque: 'u',
                scope: 'u',
                teletrans: 'u',
                vvp: 'u',
                vvp_desc: '',
                commentaire: '',
                mode_transport_infirmerie: 0,
                bilan_medecin: 'u',
                conclusion: '',
                prescription: '',
                smur_mce: 'u',
                voie_veineuse_centrale: 'u',
                intra_osseuse: 'u',
                defibrillation_smur: 'u',
                nombre_chocs: null,
                intensite: null,
                kto: 'u',
                planche_a_masser: 'u',
                entrainement_systolique_externe: 'u',
                cpia: 'u',
                ecmo: 'u',
                transfusion: null,
                sondage_gastrique: 'u',
                sondage_urinaire: 'u',
                bilan_sanguin: 'u',
                smur_vni: 'u',
                smur_vni_fio2: null,
                smur_vni_ai: null,
                smur_vni_peep: null,
                smur_vni_trigger: null,
                smur_vi: 'u',
                smur_vi_fio2: null,
                smur_vi_peep: null,
                smur_vi_fr: null,
                smur_vi_vt: null,
                smur_inhalation: 'u',
                smur_debit: null,
                smur_dispositif: null,
                smur_intubation: 'u',
                smur_diametre: null,
                smur_vi2: null,
                smur_vi_trigger: null,
                smur_intubation_difficile: 'u',
                attelle_traction: 'u',
                aerosol_nombre: null,
                vvp_nombre: null,
                vvp_diametre: null,
                intraosseuse: null,
                sondage_gastrique_diametre: null,
                sondage_urinaire_diametre: null,
                sr_desincarceration: null,
                sr_ceinture: 'u',
                sr_airbag: 'u',
                guedel: 'u',
                lva_traumatique: 'u',
                extraction_digitale: 'u',
                basculement_tete: 'u',
                examen: '',
                pansementCompressif: null,
                compr_manuelle: 'u',
                claquesDos: 'u',
                sr_cinetique: null,
                sr_position_victime_arrivee_secours: null,
                rcp_heure: null,
                rcp_temoin: 'u',
                dae_chocs: null,
                masque_hc: 'u',
                kit_membre_sectionne: 'u',
                poche_froid: 'u',
                protection_plaie: 'u',
                protection_thermique: 'u',
                refroidissement: 'u',
                maintien_os_long_fracture: 'u',
                maintien_tete: 'u',
                realignement_membre: 'u',
                retournement: 'u',
                pansement_trois_cotes: 'u',
                commentaire_cardiologique: null,
                commentaire_neurologique: null,
                protocole_text: null,
                heure_pose: null,
                heure_reprise_activite_cardiaque: null,
                is_chocs: 'u',
                mobilisation: 'u',
                relevage_technique: 'u',
                kit_accouchement: 'u',
                section_cordon_ombilical: 'u',
                kit_damage: 'u',
                attelle_cervico_thoracique: 'u',
                brancard_cuillere: 'u',
                reprise_activite_cardiaque: null,
                arret_hemorragie: 'u',
                desobstruction: 'u',
                temoin_type: null,
                matelas_depression: 'u',
                attelle_boa: 'u',
                retrait_dentier: 'u',
                nombre_chocs_inter: null,
                kit_brulure: 'u',
                dispositif_oxygeno: 0,
                pansement_type_h: null,
                ventilation_assistee: 'u',
                aide_prise_medicaments: 'u',
                stabilisation_du_rachis: 'u',
                sr_type_accident: null,
                sr_type_choc: null,
                sr_position_dans_vehicule: null,
                sr_equipement_motard: null,
                observation_thorax: 'u',
                c3dam_circonstances: null,
                c3dam_dernier_fois_vu_vivant_date: null,
                c3dam_dernier_fois_vu_vivant_time: null,
                c3dam_estimation_noflow_minutes: null,
                c3dam_atcd_contexte_fin_de_vie_connus: 'u',
                c3dam_mce_duree: null,
                c3dam_arret_rcp_apres_bilan_medecin: 'u',
                pansement_type_h_raw: 'u',
                garot_heure: null,
                pansement_compressif: 'u',
                garrot: 'u',
                quick_lock: 'u',
                pansement_hemostatique: 'u',
                temoin_pls: 'u',
                evolutions: '',
                pose_brule_stop: 'u',
                pansement3_cotes: 'u',
                pince_magill: 'u',
                auscultation_pulmonaire: 'u',
                sr_type_accident_autre: null,
                sr_equipement_victime: null,
                choix_gestes: null,
                geste_technique_sur_prescription_medicale: null,
                geste_medical: null,
                echec_pose: null,
                pisu: null,
                aucun_pisu: null,
                refus_therapeutique: null,
                consigne_mad: null,
                contact_mad: 'u',
                demande_renfort: 'u',
            },
            medic_info: {
                douleur_poitrine: 'u',
                dyspnee: 'u',
                encombrement: 'u',
                gla_yeux: '0',
                gla_motricite: '0',
                gla_parole: '0',
                hemoglobine: '-1.0',
                choc_index: '-1.0',
                pupilles: '0',
                tirage: 'u',
                glycemie: '-1.0',
                pincement_ailes_nez: 'u',
                bal_thoraco_abdominal: '0',
                commentaire: '',
                dyspnee_type: null,
                douleur_thoracique: null,
                heure_debut_douleur_poitrine: null,
                heure_debut_douleur_poitrine_time: null,
                heure_debut_douleur_poitrine_date: null,
                pupilles_bilateral: null,
                evolution: null,
                signes_digestifs: null,
                examen_tete: null,
                examen_rachis: null,
                examen_thorax: null,
                glycemie_unite: 2,
            },
            neurologique: {
                agitation: 'u',
                convulsions: 'u',
                inconscience: 'u',
                motricite_extremites: 'u',
                sensibilite_extremites: 0,
                orientation_spatiale: 'u',
                orientation_temporelle: 'u',
                paralysie_faciale: 'u',
                pci: -1,
                pupilles_anormales: 'u',
                repond_ordre: 'u',
                trouble_parole: 'u',
                temperature: -1,
                commentaire: null,
                smur_intervalle_libre: null,
                sd_meninge: 'u',
                smur_deficit: 1,
                smur_heure_debut_deficit: null,
                smur_obnubilation: 'u',
                convulsions_duree: null,
                convulsions_repetitions: null,
                smur_conscience: 1,
                smur_deficit_moteur: 1,
                heure_apparition_deficit_neurologique: null,
                trouble_equilibre: 'u',
                avpu: null,
                deficit: null,
                mouvements: null,
                sensibilite_bilateral: null,
                motricite_bilateral: null,
                smur_heure_debut_deficit_date: null,
                smur_heure_debut_deficit_time: null,
                pci_duree_indeterminee: null,
                paralysie_faciale_zonale: null,
                convulsions_repetitives: 'u',
                trouble_parole_detail: null,
                pupilles_symetriques: 'u',
                perte_urine: 'u',
                morsure_langue: 'u',
            },
            nihss: {
                vigilance: null,
                orientation: null,
                commandes: null,
                oculomotricite: null,
                champ_visuel: null,
                paralysie_faciale: null,
                motricite_membre_superieur_droit: null,
                motricite_membre_superieur_gauche: null,
                motricite_membre_inferieur_droit: null,
                motricite_membre_inferieur_gauche: null,
                ataxie: null,
                sensibilite: null,
                langage: null,
                dysarthrie: null,
                extinction_negligence: null,
            },
            obstetrique: {
                commentaire: '',
                premiere_grossesse: 'u',
                terme_actuel: '',
                contraction: 0,
                perte_eaux: 'u',
                envie_pousser: 'u',
                malinas_parite: 0,
                malinas_travail: 0,
                malinas_duree_contraction: 0,
                malinas_intervalle_contraction: 0,
                malinas_perte_eaux: 0,
                intervalle_contraction: '',
                nombre_grossesses: null,
                nombre_pars: null,
                duree_contractions: null,
                date_terme: null,
                date_dernieres_regles: null,
                saignement_estime: null,
                tete_membre_visible: 'u',
                accouchement_realise: 'u',
                section_cordon: 'u',
                gestes: 0,
                apgar_t1: {
                    fc: 0,
                    fr: 0,
                    tonus: 0,
                    reactivite: 0,
                    coloration: 0,
                },
                apgar_t5: {
                    fc: 0,
                    fr: 0,
                    tonus: 0,
                    reactivite: 0,
                    coloration: 0,
                },
            },
            respiration: {
                fv: -1,
                o2aa: -1,
                spco: -1,
                o2o2: -1,
                ample: 'u',
                arret_respiratoire: 'u',
                bruyante: 'u',
                cyanose: 'u',
                difficile: 'u',
                obva: 'u',
                pauses: 'u',
                reguliere: 'u',
                sueurs: 'u',
                superficielle: 'u',
                commentaire: '',
                smur_epanchement_liquidien: null,
                etco2: null,
                peak_flow: null,
                obva_partielle: 'u',
                obva_select: null,
                cause_obva: null,
                cause_obva_commentaire: null,
                bruits_anormaux: 'u',
                bruyante_type: null,
                battement_ailes_nez: 'u',
                balancement_thoraco_abdo: 'u',
                asymetrie_thoracique: 'u',
                emphyseme: 'u',
                toux: 'u',
                signes_lutte_respi: 'u',
                pneumothorax: 'u',
                normale: 'u',
                bpco: null,
                spco_precision: null,
                plaie_soufflante: 'u',
            },
            surveillances: [
                {
                    inconscience: 'u',
                    heure: '-1',
                    minute: '-1',
                    fr: '-1',
                    fc: '-1',
                    spo2: '-1',
                    pabg: '',
                    pabd: '',
                    pambd: null,
                    pambg: null,
                    commentaire: '',
                    glycemie: -1,
                    eva: -1,
                    score_sedation: -1,
                    hemoglobine_float: -1,
                    pupilles: 0,
                    glasgow: null,
                    gla_yeux: 0,
                    gla_parole: 0,
                    gla_motricite: 0,
                    peak_flow: null,
                    etco2: null,
                    temperature: null,
                    avpu: null,
                    glasgow_yeux: -1,
                    glasgow_verbal: -1,
                    glasgow_motricite: -1,
                    spco: null,
                    hemoglobine: null,
                    choc_index: -1,
                    hemocue: null,
                    glycemie_unite: 0,
                    apgar: {
                        fc: 0,
                        fr: 0,
                        tonus: 0,
                        reactivite: 0,
                        coloration: 0,
                    },
                    medics: [],
                },
            ],
            trauma: {
                desc_arriere: '',
                desc_avant: '',
                desc_main_gauche: '',
                desc_main_droit: '',
                desc_pied_gauche: '',
                desc_pied_droit: '',
                dummy: {
                    lesionnel_arriere: {
                        arriere_avant_bras_droit: 0,
                        arriere_jambe_gauche: 0,
                        arriere_tete: 0,
                        arriere_pied_gauche: 0,
                        arriere_colonne_vertebrale_bas: 0,
                        arriere_articulation_bras_gauche: 0,
                        arriere_main_droite: 0,
                        arriere_cuisse_gauche: 0,
                        arriere_avant_bras_gauche: 0,
                        arriere_bassin_haut: 0,
                        arriere_main_gauche: 0,
                        arriere_jambe_droite: 0,
                        arriere_cuisse_droite: 0,
                        arriere_haut_bras_gauche: 0,
                        arriere_articulation_pied_gauche: 0,
                        arriere_epaule_droite: 0,
                        arriere_poignet_gauche: 0,
                        arriere_pied_droit: 0,
                        arriere_epaule_gauche: 0,
                        arriere_genou_droit: 0,
                        arriere_genou_gauche: 0,
                        arriere_dos: 0,
                        arriere_colonne_vertebrale_haut: 0,
                        arriere_articulation_pied_droit: 0,
                        arriere_poignet_droit: 0,
                        arriere_haut_bras_droit: 0,
                        arriere_bassin_bas: 0,
                        arriere_articulation_bras_droit: 0,
                        arriere_nuque: 0,
                    },
                    lesionnel_avant: {
                        avant_cuisse_droite: 0,
                        avant_articulation_bras_droit: 0,
                        avant_poignet_gauche: 0,
                        avant_pied_gauche: 0,
                        avant_epaule_droite: 0,
                        avant_genou_gauche: 0,
                        avant_articulation_bras_gauche: 0,
                        avant_haut_bras_droit: 0,
                        avant_epaule_gauche: 0,
                        avant_haut_bras_gauche: 0,
                        avant_pied_droit: 0,
                        avant_avant_bras_gauche: 0,
                        avant_main_droite: 0,
                        avant_bas_bassin: 0,
                        avant_jambe_gauche: 0,
                        avant_bas_corps: 0,
                        avant_jambe_droite: 0,
                        avant_main_gauche: 0,
                        avant_bassin: 0,
                        avant_cou: 0,
                        avant_cuisse_gauche: 0,
                        avant_poignet_droit: 0,
                        avant_tete: 0,
                        avant_haut_corps: 0,
                        avant_avant_bras_droit: 0,
                        avant_articulation_pied_gauche: 0,
                        avant_genou_droit: 0,
                        avant_articulation_pied_droit: 0,
                    },
                    lesionnel_arriere_v2: {
                        arriere_tete: 0,
                        arriere_nuque: 0,
                        arriere_buste_droit: 0,
                        arriere_buste_gauche: 0,
                        arriere_epaule_droit: 0,
                        arriere_epaule_gauche: 0,
                        arriere_bras_droit: 0,
                        arriere_bras_gauche: 0,
                        arriere_coude_droit: 0,
                        arriere_coude_gauche: 0,
                        arriere_avant_bras_droit: 0,
                        arriere_avant_bras_gauche: 0,
                        arriere_poignet_droit: 0,
                        arriere_poignet_gauche: 0,
                        arriere_main_droit: 0,
                        arriere_main_gauche: 0,
                        arriere_bassin_gauche: 0,
                        arriere_bassin_droit: 0,
                        arriere_bas_bassin: 0,
                        arriere_cuisse_droit: 0,
                        arriere_cuisse_gauche: 0,
                        arriere_genou_droit: 0,
                        arriere_genou_gauche: 0,
                        arriere_jambe_droit: 0,
                        arriere_jambe_gauche: 0,
                        arriere_cheville_droit: 0,
                        arriere_cheville_gauche: 0,
                        arriere_pied_droit: 0,
                        arriere_pied_gauche: 0,
                        arriere_dorsal_gauche: 0,
                        arriere_dorsal_droit: 0,
                        arriere_lombaire_droit: 0,
                        arriere_lombaire_gauche: 0,
                        arriere_fesse_gauche: 0,
                        arriere_fesse_droit: 0,
                    },
                    lesionnel_avant_v2: {
                        avant_coude_droit: 0,
                        avant_epaule_droit: 0,
                        avant_flanc_gauche: 0,
                        avant_bassin_droit: 0,
                        avant_main_droit: 0,
                        avant_hypocondre_droit: 0,
                        avant_main_gauche: 0,
                        avant_pied_droit: 0,
                        avant_pied_gauche: 0,
                        avant_epaule_gauche: 0,
                        avant_coude_gauche: 0,
                        avant_tete: 0,
                        avant_genou_gauche: 0,
                        avant_genou_droit: 0,
                        avant_cuisse_gauche: 0,
                        avant_jambe_droit: 0,
                        avant_cuisse_droit: 0,
                        avant_jambe_gauche: 0,
                        avant_cheville_gauche: 0,
                        avant_genital: 0,
                        avant_avant_bras_gauche: 0,
                        avant_cou: 0,
                        avant_bras_droit: 0,
                        avant_cheville_droit: 0,
                        avant_avant_bras_droit: 0,
                        avant_hypocondre_gauche: 0,
                        avant_bras_gauche: 0,
                        avant_poignet_droit: 0,
                        avant_fosse_iliaque_gauche: 0,
                        avant_flanc_droit: 0,
                        avant_fosse_iliaque_droit: 0,
                        avant_ombilicale: 0,
                        avant_epigastrique: 0,
                        avant_buste_gauche: 0,
                        avant_poignet_gauche: 0,
                        avant_bassin_gauche: 0,
                        avant_buste_droit: 0,
                        avant_hypogastrique: 0,
                    },
                    lesionnel_main_gauche_v2: {
                        avant_gauche_paume: 0,
                        avant_gauche_poignet_gauche: 0,
                        avant_gauche_phalange_pouce_proximale: 0,
                        avant_gauche_phalange_pouce_distale: 0,
                        avant_gauche_articulation_pouce_interne: 0,
                        avant_gauche_articulation_pouce_externe: 0,
                        avant_gauche_ongle_pouce: 0,
                        avant_gauche_ongle_index: 0,
                        avant_gauche_phalange_index_proximale: 0,
                        avant_gauche_phalange_index_mediane: 0,
                        avant_gauche_phalange_index_distale: 0,
                        avant_gauche_articulation_index_interne: 0,
                        avant_gauche_articulation_index_mediane: 0,
                        avant_gauche_articulation_index_externe: 0,
                        avant_gauche_ongle_majeur: 0,
                        avant_gauche_phalange_majeur_proximale: 0,
                        avant_gauche_phalange_majeur_mediane: 0,
                        avant_gauche_phalange_majeur_distale: 0,
                        avant_gauche_articulation_majeur_interne: 0,
                        avant_gauche_articulation_majeur_mediane: 0,
                        avant_gauche_articulation_majeur_externe: 0,
                        avant_gauche_ongle_annulaire: 0,
                        avant_gauche_phalange_annulaire_proximale: 0,
                        avant_gauche_phalange_annulaire_mediane: 0,
                        avant_gauche_phalange_annulaire_distale: 0,
                        avant_gauche_articulation_annulaire_interne: 0,
                        avant_gauche_articulation_annulaire_mediane: 0,
                        avant_gauche_articulation_annulaire_externe: 0,
                        avant_gauche_ongle_auriculaire: 0,
                        avant_gauche_phalange_auriculaire_proximale: 0,
                        avant_gauche_phalange_auriculaire_mediane: 0,
                        avant_gauche_phalange_auriculaire_distale: 0,
                        avant_gauche_articulation_auriculaire_interne: 0,
                        avant_gauche_articulation_auriculaire_mediane: 0,
                        avant_gauche_articulation_auriculaire_externe: 0,
                        arriere_gauche_poignet_gauche: 0,
                        arriere_gauche_thenar: 0,
                        arriere_gauche_paume: 0,
                        arriere_gauche_phalange_pouce_proximale: 0,
                        arriere_gauche_phalange_pouce_distale: 0,
                        arriere_gauche_articulation_pouce_interne: 0,
                        arriere_gauche_articulation_pouce_externe: 0,
                        arriere_gauche_phalange_index_proximale: 0,
                        arriere_gauche_phalange_index_mediane: 0,
                        arriere_gauche_phalange_index_distale: 0,
                        arriere_gauche_articulation_index_interne: 0,
                        arriere_gauche_articulation_index_mediane: 0,
                        arriere_gauche_articulation_index_externe: 0,
                        arriere_gauche_phalange_majeur_proximale: 0,
                        arriere_gauche_phalange_majeur_mediane: 0,
                        arriere_gauche_phalange_majeur_distale: 0,
                        arriere_gauche_articulation_majeur_interne: 0,
                        arriere_gauche_articulation_majeur_mediane: 0,
                        arriere_gauche_articulation_majeur_externe: 0,
                        arriere_gauche_phalange_annulaire_proximale: 0,
                        arriere_gauche_phalange_annulaire_mediane: 0,
                        arriere_gauche_phalange_annulaire_distale: 0,
                        arriere_gauche_articulation_annulaire_interne: 0,
                        arriere_gauche_articulation_annulaire_mediane: 0,
                        arriere_gauche_articulation_annulaire_externe: 0,
                        arriere_gauche_phalange_auriculaire_proximale: 0,
                        arriere_gauche_phalange_auriculaire_mediane: 0,
                        arriere_gauche_phalange_auriculaire_distale: 0,
                        arriere_gauche_articulation_auriculaire_interne: 0,
                        arriere_gauche_articulation_auriculaire_mediane: 0,
                        arriere_gauche_articulation_auriculaire_externe: 0,
                    },
                    lesionnel_main_droit_v2: {
                        avant_droit_paume: 0,
                        avant_droit_poignet_droit: 0,
                        avant_droit_phalange_pouce_proximale: 0,
                        avant_droit_phalange_pouce_distale: 0,
                        avant_droit_articulation_pouce_interne: 0,
                        avant_droit_articulation_pouce_externe: 0,
                        avant_droit_ongle_pouce: 0,
                        avant_droit_ongle_index: 0,
                        avant_droit_phalange_index_proximale: 0,
                        avant_droit_phalange_index_mediane: 0,
                        avant_droit_phalange_index_distale: 0,
                        avant_droit_articulation_index_interne: 0,
                        avant_droit_articulation_index_mediane: 0,
                        avant_droit_articulation_index_externe: 0,
                        avant_droit_ongle_majeur: 0,
                        avant_droit_phalange_majeur_proximale: 0,
                        avant_droit_phalange_majeur_mediane: 0,
                        avant_droit_phalange_majeur_distale: 0,
                        avant_droit_articulation_majeur_interne: 0,
                        avant_droit_articulation_majeur_mediane: 0,
                        avant_droit_articulation_majeur_externe: 0,
                        avant_droit_ongle_annulaire: 0,
                        avant_droit_phalange_annulaire_proximale: 0,
                        avant_droit_phalange_annulaire_mediane: 0,
                        avant_droit_phalange_annulaire_distale: 0,
                        avant_droit_articulation_annulaire_interne: 0,
                        avant_droit_articulation_annulaire_mediane: 0,
                        avant_droit_articulation_annulaire_externe: 0,
                        avant_droit_ongle_auriculaire: 0,
                        avant_droit_phalange_auriculaire_proximale: 0,
                        avant_droit_phalange_auriculaire_mediane: 0,
                        avant_droit_phalange_auriculaire_distale: 0,
                        avant_droit_articulation_auriculaire_interne: 0,
                        avant_droit_articulation_auriculaire_mediane: 0,
                        avant_droit_articulation_auriculaire_externe: 0,
                        arriere_droit_poignet_droit: 0,
                        arriere_droit_thenar: 0,
                        arriere_droit_paume: 0,
                        arriere_droit_phalange_pouce_proximale: 0,
                        arriere_droit_phalange_pouce_distale: 0,
                        arriere_droit_articulation_pouce_interne: 0,
                        arriere_droit_articulation_pouce_externe: 0,
                        arriere_droit_phalange_index_proximale: 0,
                        arriere_droit_phalange_index_mediane: 0,
                        arriere_droit_phalange_index_distale: 0,
                        arriere_droit_articulation_index_interne: 0,
                        arriere_droit_articulation_index_mediane: 0,
                        arriere_droit_articulation_index_externe: 0,
                        arriere_droit_phalange_majeur_proximale: 0,
                        arriere_droit_phalange_majeur_mediane: 0,
                        arriere_droit_phalange_majeur_distale: 0,
                        arriere_droit_articulation_majeur_interne: 0,
                        arriere_droit_articulation_majeur_mediane: 0,
                        arriere_droit_articulation_majeur_externe: 0,
                        arriere_droit_phalange_annulaire_proximale: 0,
                        arriere_droit_phalange_annulaire_mediane: 0,
                        arriere_droit_phalange_annulaire_distale: 0,
                        arriere_droit_articulation_annulaire_interne: 0,
                        arriere_droit_articulation_annulaire_mediane: 0,
                        arriere_droit_articulation_annulaire_externe: 0,
                        arriere_droit_phalange_auriculaire_proximale: 0,
                        arriere_droit_phalange_auriculaire_mediane: 0,
                        arriere_droit_phalange_auriculaire_distale: 0,
                        arriere_droit_articulation_auriculaire_interne: 0,
                        arriere_droit_articulation_auriculaire_mediane: 0,
                        arriere_droit_articulation_auriculaire_externe: 0,
                    },
                    lesionnel_pied_gauche_v2: {
                        avant_gauche_cheville: 0,
                        avant_gauche_os: 0,
                        avant_gauche_avant_interne: 0,
                        avant_gauche_avant_externe: 0,
                        avant_gauche_arriere_externe: 0,
                        avant_gauche_arriere_interne: 0,
                        avant_gauche_ongle_hallux: 0,
                        avant_gauche_articulation_hallux_externe: 0,
                        avant_gauche_articulation_hallux_interne: 0,
                        avant_gauche_phalange_hallux_distale: 0,
                        avant_gauche_phalange_hallux_proximale: 0,
                        avant_gauche_ongle_secundus: 0,
                        avant_gauche_articulation_secundus_externe: 0,
                        avant_gauche_articulation_secundus_interne: 0,
                        avant_gauche_phalange_secundus_distale: 0,
                        avant_gauche_phalange_secundus_proximale: 0,
                        avant_gauche_ongle_tertius: 0,
                        avant_gauche_articulation_tertius_externe: 0,
                        avant_gauche_articulation_tertius_interne: 0,
                        avant_gauche_phalange_tertius_distale: 0,
                        avant_gauche_phalange_tertius_proximale: 0,
                        avant_gauche_ongle_quartus: 0,
                        avant_gauche_articulation_quartus_externe: 0,
                        avant_gauche_articulation_quartus_interne: 0,
                        avant_gauche_phalange_quartus_distale: 0,
                        avant_gauche_phalange_quartus_proximale: 0,
                        avant_gauche_ongle_quintus: 0,
                        avant_gauche_articulation_quintus_interne: 0,
                        avant_gauche_phalange_quintus_proximale: 0,
                        arriere_gauche_talon_externe: 0,
                        arriere_gauche_talon_interne: 0,
                        arriere_gauche_medio_interne: 0,
                        arriere_gauche_medio_externe: 0,
                        arriere_gauche_plante_rond: 0,
                        arriere_gauche_plante_externe: 0,
                        arriere_gauche_plante_interne: 0,
                        arriere_gauche_articulation_hallux_externe: 0,
                        arriere_gauche_articulation_hallux_interne: 0,
                        arriere_gauche_phalange_hallux_distale: 0,
                        arriere_gauche_phalange_hallux_proximale: 0,
                        arriere_gauche_articulation_secundus_externe: 0,
                        arriere_gauche_articulation_secundus_interne: 0,
                        arriere_gauche_phalange_secundus_distale: 0,
                        arriere_gauche_phalange_secondus_proximale: 0,
                        arriere_gauche_articulation_tertius_externe: 0,
                        arriere_gauche_articulation_tertius_interne: 0,
                        arriere_gauche_phalange_tertius_distale: 0,
                        arriere_gauche_phalange_tertius_proximale: 0,
                        arriere_gauche_articulation_quartus_externe: 0,
                        arriere_gauche_articulation_quartus_interne: 0,
                        arriere_gauche_phalange_quartus_distale: 0,
                        arriere_gauche_phalange_quartus_proximale: 0,
                        arriere_gauche_articulation_quintus_interne: 0,
                        arriere_gauche_phalange_quintus_distale: 0,
                    },
                    lesionnel_pied_droit_v2: {
                        avant_droit_cheville: 0,
                        avant_droit_os: 0,
                        avant_droit_avant_interne: 0,
                        avant_droit_avant_externe: 0,
                        avant_droit_arriere_externe: 0,
                        avant_droit_arriere_interne: 0,
                        avant_droit_ongle_hallux: 0,
                        avant_droit_articulation_hallux_externe: 0,
                        avant_droit_articulation_hallux_interne: 0,
                        avant_droit_phalange_hallux_distale: 0,
                        avant_droit_phalange_hallux_proximale: 0,
                        avant_droit_ongle_secundus: 0,
                        avant_droit_articulation_secundus_externe: 0,
                        avant_droit_articulation_secundus_interne: 0,
                        avant_droit_phalange_secundus_distale: 0,
                        avant_droit_phalange_secundus_proximale: 0,
                        avant_droit_ongle_tertius: 0,
                        avant_droit_articulation_tertius_externe: 0,
                        avant_droit_articulation_tertius_interne: 0,
                        avant_droit_phalange_tertius_distale: 0,
                        avant_droit_phalange_tertius_proximale: 0,
                        avant_droit_ongle_quartus: 0,
                        avant_droit_articulation_quartus_externe: 0,
                        avant_droit_articulation_quartus_interne: 0,
                        avant_droit_phalange_quartus_distale: 0,
                        avant_droit_phalange_quartus_proximale: 0,
                        avant_droit_ongle_quintus: 0,
                        avant_droit_articulation_quintus_interne: 0,
                        avant_droit_phalange_quintus_proximale: 0,
                        arriere_droit_talon_externe: 0,
                        arriere_droit_talon_interne: 0,
                        arriere_droit_medio_interne: 0,
                        arriere_droit_medio_externe: 0,
                        arriere_droit_plante_rond: 0,
                        arriere_droit_plante_externe: 0,
                        arriere_droit_plante_interne: 0,
                        arriere_droit_articulation_hallux_externe: 0,
                        arriere_droit_articulation_hallux_interne: 0,
                        arriere_droit_phalange_hallux_distale: 0,
                        arriere_droit_phalange_hallux_proximale: 0,
                        arriere_droit_articulation_secundus_externe: 0,
                        arriere_droit_articulation_secundus_interne: 0,
                        arriere_droit_phalange_secundus_distale: 0,
                        arriere_droit_phalange_secondus_proximale: 0,
                        arriere_droit_articulation_tertius_externe: 0,
                        arriere_droit_articulation_tertius_interne: 0,
                        arriere_droit_phalange_tertius_distale: 0,
                        arriere_droit_phalange_tertius_proximale: 0,
                        arriere_droit_articulation_quartus_externe: 0,
                        arriere_droit_articulation_quartus_interne: 0,
                        arriere_droit_phalange_quartus_distale: 0,
                        arriere_droit_phalange_quartus_proximale: 0,
                        arriere_droit_articulation_quintus_interne: 0,
                        arriere_droit_phalange_quintus_distale: 0,
                    },
                    lesionnel_tete_avant_v2: {
                        avant_front_milieu: 0,
                        avant_front_gauche: 0,
                        avant_front_droit: 0,
                        avant_entre_sourcils: 0,
                        avant_arcade_gauche: 0,
                        avant_arcade_droit: 0,
                        avant_orbite_droit: 0,
                        avant_orbite_gauche: 0,
                        avant_zone_nez: 0,
                        avant_pommette_gauche: 0,
                        avant_pommette_droit: 0,
                        avant_joue_gauche: 0,
                        avant_joue_droit: 0,
                        avant_menton: 0,
                        avant_entre_yeux: 0,
                        avant_cou_milieu: 0,
                        avant_cou_droit: 0,
                        avant_cou_gauche: 0,
                        avant_oreille_gauche: 0,
                        avant_oreille_droit: 0,
                        avant_zone_bouche: 0,
                        bouche_langue: 0,
                        bouche_palais: 0,
                        bouche_dents_bas: 0,
                        bouche_levres_inferieures: 0,
                        bouche_dents_haut: 0,
                        bouche_levres_superieures: 0,
                        bouche_gencive_haut: 0,
                    },
                },
            },
            victime: {
                poids: -1,
                heure_dernier_repas: '',
                medecin_traitant: '',
                medecin_num: '',
                commentaire: '',
                nom: '',
                prenom: '',
                adresse: '',
                sexe: '0',
                age: '',
                date_naissance: '',
                telephone: '',
                secu: '',
                plainte: '',
                contact_prevenu: false,
                contact_nom: '',
                contact_lien: '',
                contact_telephone: '',
                maladies: '',
                hospitalisations: '',
                traitements: '',
                antecedents: '',
                mutuelle: '',
                jeunefille: '',
                pdf_salarie: '',
                caisse_assurance_maladie: '',
                email: null,
                taille: -1,
                heure_dernier_repas_time: null,
                heure_dernier_repas_date: null,
                age_unit: null,
                antecedents_yn: 'u',
                telephone_parent: '',
                telephone_temoin: '',
                heure_naissance: null,
                civilite: 0,
                risques: 0,
            },
        },
    },
    info_tech: {
        conformite: 0,
        conformite_id: 0,
        id_intervention: null,
        proprietaire: '',
        regulation_id: 0,
        typ: 'SECOURISTE',
        smur_mission: null,
        corpuls_mission_id: null,
        sinus_serial: null,
    },
});
exports.TEXTIFY_FRONT = [
    ['avant_tete', 'Tête'],
    ['avant_cou', 'Cou'],
    ['avant_oreille_gauche', 'Oreille gauche'],
    ['avant_oreille_droit', 'Oreille droite'],
    ['avant_buste_droit', 'Buste droit'],
    ['avant_buste_gauche', 'Buste gauche'],
    ['avant_hypocondre_droit', 'Hypocondre droit'],
    ['avant_epigastrique', 'Épigastrique'],
    ['avant_hypocondre_gauche', 'Hypocondre gauche'],
    ['avant_flanc_droit', 'Flanc droit'],
    ['avant_ombilicale', 'Ombilicale'],
    ['avant_flanc_gauche', 'Flanc gauche'],
    ['avant_fosse_iliaque_droit', 'Fosse iliaque droit'],
    ['avant_hypogastrique', 'Hypogastrique'],
    ['avant_fosse_iliaque_gauche', 'Fosse iliaque gauche'],
    ['avant_bassin_droit', 'Bassin droit'],
    ['avant_genital', 'Génital'],
    ['avant_bassin_gauche', 'Bassin gauche'],
    ['avant_haut_corps', 'Thorax'],
    ['avant_bas_corps', 'Abdomen'],
    ['avant_bassin', 'Bassin'],
    ['avant_bas_bassin', 'OGE'],
    ['avant_epaule_droite', 'Epaule droite'],
    ['avant_epaule_droit', 'Epaule droite'],
    ['avant_haut_bras_droit', 'Bras droit'],
    ['avant_bras_droit', 'Bras droit'],
    ['avant_articulation_bras_droit', 'Coude droit'],
    ['avant_coude_droit', 'Coude droit'],
    ['avant_avant_bras_droit', 'Avant-bras droit'],
    ['avant_poignet_droit', 'Poignet droit'],
    ['avant_main_droite', 'Main droite'],
    ['avant_main_droit', 'Main droite'],
    ['avant_epaule_gauche', 'Epaule gauche'],
    ['avant_haut_bras_gauche', 'Bras gauche'],
    ['avant_bras_gauche', 'Bras gauche'],
    ['avant_articulation_bras_gauche', 'Coude gauche'],
    ['avant_coude_gauche', 'Coude gauche'],
    ['avant_avant_bras_gauche', 'Avant-bras gauche'],
    ['avant_poignet_gauche', 'Poignet gauche'],
    ['avant_main_gauche', 'Main gauche'],
    ['avant_cuisse_droite', 'Cuisse droite'],
    ['avant_cuisse_droit', 'Cuisse droite'],
    ['avant_genou_droit', 'Genou droit'],
    ['avant_jambe_droite', 'Mollet droit'],
    ['avant_jambe_droit', 'Mollet droit'],
    ['avant_articulation_pied_droit', 'Cheville droite'],
    ['avant_cheville_droit', 'Cheville droite'],
    ['avant_pied_droit', 'Pied droit'],
    ['avant_cuisse_gauche', 'Cuisse gauche'],
    ['avant_genou_gauche', 'Genou gauche'],
    ['avant_jambe_gauche', 'Mollet gauche'],
    ['avant_articulation_pied_gauche', 'Cheville gauche'],
    ['avant_cheville_gauche', 'Cheville gauche'],
    ['avant_pied_gauche', 'Pied gauche'],
];
exports.TEXTIFY_BACK = [
    ['arriere_tete', 'Tête'],
    ['arriere_nuque', 'Nuque'],
    ['arriere_colonne_vertebrale_haut', 'Colonne vertebrale haut'],
    ['arriere_bassin_haut', 'Bassin'],
    ['arriere_dos', 'Dos'],
    ['arriere_colonne_vertebrale_bas', 'Colonne vertebrale bas'],
    ['arriere_bassin_bas', 'OGE'],
    ['arriere_buste_gauche', 'Buste gauche'],
    ['arriere_buste_droit', 'Buste droit'],
    ['arriere_dorsal_gauche', 'Dorsal gauche'],
    ['arriere_dorsal_droit', 'Dorsal droit'],
    ['arriere_lombaire_gauche', 'Lombaire gauche'],
    ['arriere_lombaire_droit', 'Lombaire droit'],
    ['arriere_bassin_gauche', 'Bassin gauche'],
    ['arriere_bassin_droit', 'Bassin droit'],
    ['arriere_epaule_gauche', 'Epaule gauche'],
    ['arriere_haut_bras_gauche', 'Bras gauche'],
    ['arriere_bras_gauche', 'Bras gauche'],
    ['arriere_coude_gauche', 'Coude gauche'],
    ['arriere_articulation_bras_gauche', 'Coude gauche'],
    ['arriere_avant_bras_gauche', 'Avant-bras gauche'],
    ['arriere_poignet_gauche', 'Poignet gauche'],
    ['arriere_main_gauche', 'Main gauche'],
    ['arriere_epaule_droite', 'Epaule droite'],
    ['arriere_epaule_droit', 'Epaule droite'],
    ['arriere_haut_bras_droit', 'Bras droit'],
    ['arriere_bras_droit', 'Bras droit'],
    ['arriere_coude_droit', 'Coude droit'],
    ['arriere_articulation_bras_droit', 'Coude droit'],
    ['arriere_avant_bras_droit', 'Avant-bras droit'],
    ['arriere_poignet_droit', 'Poignet droit'],
    ['arriere_main_droite', 'Main droite'],
    ['arriere_main_droit', 'Main droite'],
    ['arriere_fesse_gauche', 'Fesse gauche'],
    ['arriere_cuisse_gauche', 'Cuisse gauche'],
    ['arriere_genou_gauche', 'Genou gauche'],
    ['arriere_jambe_gauche', 'Mollet gauche'],
    ['arriere_cheville_gauche', 'Cheville gauche'],
    ['arriere_articulation_pied_gauche', 'Cheville gauche'],
    ['arriere_pied_gauche', 'Pied gauche'],
    ['arriere_fesse_droit', 'Fesse droite'],
    ['arriere_cuisse_droite', 'Cuisse droite'],
    ['arriere_cuisse_droit', 'Cuisse droite'],
    ['arriere_genou_droit', 'Genou droit'],
    ['arriere_jambe_droite', 'Mollet droit'],
    ['arriere_jambe_droit', 'Mollet droit'],
    ['arriere_cheville_droit', 'Cheville droite'],
    ['arriere_articulation_pied_droit', 'Cheville droite'],
    ['arriere_pied_droit', 'Pied droit'],
    ['arriere_colonne_haut', 'Colonne haut'],
    ['arriere_colonne_milieu_haut', 'Colonne milieu haut'],
    ['arriere_colonne_milieu_bas', 'Colonne milieu bas'],
    ['arriere_colonne_bas', 'Colonne bas'],
];
exports.TEXTIFY_FRONT_HAND_RIGHT = [
    ['avant_droit_paume', 'Paume'],
    ['avant_droit_poignet_droit', 'Poignet'],
    ['avant_droit_phalange_pouce_proximale', 'Pouce 1ere phalange'],
    ['avant_droit_phalange_pouce_distale', 'Pouce 2eme phalange'],
    ['avant_droit_articulation_pouce_interne', 'Pouce articulation MCP'],
    ['avant_droit_articulation_pouce_externe', 'Pouce articulation IP'],
    ['avant_droit_ongle_pouce', 'Pouce ongle'],
    ['avant_droit_ongle_index', 'Index ongle'],
    ['avant_droit_phalange_index_proximale', 'Index 1ere phalange'],
    ['avant_droit_phalange_index_mediane', 'Index 2eme phalange'],
    ['avant_droit_phalange_index_distale', 'Index 3eme phalange'],
    ['avant_droit_articulation_index_interne', 'Index articulation MCP'],
    ['avant_droit_articulation_index_mediane', 'Index articulation PIP'],
    ['avant_droit_articulation_index_externe', 'Index articulation DIP'],
    ['avant_droit_ongle_majeur', 'Majeur ongle'],
    ['avant_droit_phalange_majeur_proximale', 'Majeur 1ere phalange'],
    ['avant_droit_phalange_majeur_mediane', 'Majeur 2eme phalange'],
    ['avant_droit_phalange_majeur_distale', 'Majeur 3eme phalange'],
    ['avant_droit_articulation_majeur_interne', 'Majeur articulation MCP'],
    ['avant_droit_articulation_majeur_mediane', 'Majeur articulation PIP'],
    ['avant_droit_articulation_majeur_externe', 'Majeur articulation DIP'],
    ['avant_droit_ongle_annulaire', 'Annulaire ongle'],
    ['avant_droit_phalange_annulaire_proximale', 'Annulaire 1ere phalange'],
    ['avant_droit_phalange_annulaire_mediane', 'Annulaire 2eme phalange'],
    ['avant_droit_phalange_annulaire_distale', 'Annulaire 3eme phalange'],
    ['avant_droit_articulation_annulaire_interne', 'Annulaire articulation MCP'],
    ['avant_droit_articulation_annulaire_mediane', 'Annulaire articulation PIP'],
    ['avant_droit_articulation_annulaire_externe', 'Annulaire articulation DIP'],
    ['avant_droit_ongle_auriculaire', 'Auriculaire ongle'],
    ['avant_droit_phalange_auriculaire_proximale', 'Auriculaire 1ere phalange'],
    ['avant_droit_phalange_auriculaire_mediane', 'Auriculaire 2eme phalange'],
    ['avant_droit_phalange_auriculaire_distale', 'Auriculaire 3eme phalange'],
    ['avant_droit_articulation_auriculaire_interne', 'Auriculaire articulation MCP'],
    ['avant_droit_articulation_auriculaire_mediane', 'Auriculaire articulation PIP'],
    ['avant_droit_articulation_auriculaire_externe', 'Auriculaire articulation DIP'],
];
exports.TEXTIFY_FRONT_HAND_LEFT = [
    ['avant_gauche_paume', 'Paume'],
    ['avant_gauche_poignet_gauche', 'Poignet'],
    ['avant_gauche_phalange_pouce_proximale', 'Pouce 1ere phalange'],
    ['avant_gauche_phalange_pouce_distale', 'Pouce 2eme phalange'],
    ['avant_gauche_articulation_pouce_interne', 'Pouce articulation MCP'],
    ['avant_gauche_articulation_pouce_externe', 'Pouce articulation IP'],
    ['avant_gauche_ongle_pouce', 'Pouce ongle'],
    ['avant_gauche_ongle_index', 'Index ongle'],
    ['avant_gauche_phalange_index_proximale', 'Index 1ere phalange'],
    ['avant_gauche_phalange_index_mediane', 'Index 2eme phalange'],
    ['avant_gauche_phalange_index_distale', 'Index 3eme phalange'],
    ['avant_gauche_articulation_index_interne', 'Index articulation MCP'],
    ['avant_gauche_articulation_index_mediane', 'Index articulation PIP'],
    ['avant_gauche_articulation_index_externe', 'Index articulation DIP'],
    ['avant_gauche_ongle_majeur', 'Majeur ongle'],
    ['avant_gauche_phalange_majeur_proximale', 'Majeur 1ere phalange'],
    ['avant_gauche_phalange_majeur_mediane', 'Majeur 2eme phalange'],
    ['avant_gauche_phalange_majeur_distale', 'Majeur 3eme phalange'],
    ['avant_gauche_articulation_majeur_interne', 'Majeur articulation MCP'],
    ['avant_gauche_articulation_majeur_mediane', 'Majeur articulation PIP'],
    ['avant_gauche_articulation_majeur_externe', 'Majeur articulation DIP'],
    ['avant_gauche_ongle_annulaire', 'Annulaire ongle'],
    ['avant_gauche_phalange_annulaire_proximale', 'Annulaire 1ere phalange'],
    ['avant_gauche_phalange_annulaire_mediane', 'Annulaire 2eme phalange'],
    ['avant_gauche_phalange_annulaire_distale', 'Annulaire 3eme phalange'],
    ['avant_gauche_articulation_annulaire_interne', 'Annulaire articulation MCP'],
    ['avant_gauche_articulation_annulaire_mediane', 'Annulaire articulation PIP'],
    ['avant_gauche_articulation_annulaire_externe', 'Annulaire articulation DIP'],
    ['avant_gauche_ongle_auriculaire', 'Auriculaire ongle'],
    ['avant_gauche_phalange_auriculaire_proximale', 'Auriculaire 1ere phalange'],
    ['avant_gauche_phalange_auriculaire_mediane', 'Auriculaire 2eme phalange'],
    ['avant_gauche_phalange_auriculaire_distale', 'Auriculaire 3eme phalange'],
    ['avant_gauche_articulation_auriculaire_interne', 'Auriculaire articulation MCP'],
    ['avant_gauche_articulation_auriculaire_mediane', 'Auriculaire articulation PIP'],
    ['avant_gauche_articulation_auriculaire_externe', 'Auriculaire articulation DIP'],
];
exports.TEXTIFY_BACK_HAND_RIGHT = [
    ['arriere_droit_poignet_droit', 'Poignet'],
    ['arriere_droit_thenar', 'Thénar'],
    ['arriere_droit_paume', 'Paume'],
    ['arriere_droit_phalange_pouce_proximale', 'Pouce 1ere phalange'],
    ['arriere_droit_phalange_pouce_distale', 'Pouce 2eme phalange'],
    ['arriere_droit_articulation_pouce_interne', 'Pouce articulation MCP'],
    ['arriere_droit_articulation_pouce_externe', 'Pouce articulation IP'],
    ['arriere_droit_phalange_index_proximale', 'Index 1ere phalange'],
    ['arriere_droit_phalange_index_mediane', 'Index 2eme phalange'],
    ['arriere_droit_phalange_index_distale', 'Index 3eme phalange'],
    ['arriere_droit_articulation_index_interne', 'Index articulation MCP'],
    ['arriere_droit_articulation_index_mediane', 'Index articulation PIP'],
    ['arriere_droit_articulation_index_externe', 'Index articulation DIP'],
    ['arriere_droit_phalange_majeur_proximale', 'Majeur 1ere phalange'],
    ['arriere_droit_phalange_majeur_mediane', 'Majeur 2eme phalange'],
    ['arriere_droit_phalange_majeur_distale', 'Majeur 3eme phalange'],
    ['arriere_droit_articulation_majeur_interne', 'Majeur articulation MCP'],
    ['arriere_droit_articulation_majeur_mediane', 'Majeur articulation PIP'],
    ['arriere_droit_articulation_majeur_externe', 'Majeur articulation DIP'],
    ['arriere_droit_phalange_annulaire_proximale', 'Annulaire 1ere phalange'],
    ['arriere_droit_phalange_annulaire_mediane', 'Annulaire 2eme phalange'],
    ['arriere_droit_phalange_annulaire_distale', 'Annulaire 3eme phalange'],
    ['arriere_droit_articulation_annulaire_interne', 'Annulaire articulation MCP'],
    ['arriere_droit_articulation_annulaire_mediane', 'Annulaire articulation PIP'],
    ['arriere_droit_articulation_annulaire_externe', 'Annulaire articulation DIP'],
    ['arriere_droit_phalange_auriculaire_proximale', 'Auriculaire 1ere phalange'],
    ['arriere_droit_phalange_auriculaire_mediane', 'Auriculaire 2eme phalange'],
    ['arriere_droit_phalange_auriculaire_distale', 'Auriculaire 3eme phalange'],
    ['arriere_droit_articulation_auriculaire_interne', 'Auriculaire articulation MCP'],
    ['arriere_droit_articulation_auriculaire_mediane', 'Auriculaire articulation PIP'],
    ['arriere_droit_articulation_auriculaire_externe', 'Auriculaire articulation DIP'],
];
exports.TEXTIFY_BACK_HAND_LEFT = [
    ['arriere_gauche_poignet_gauche', 'Poignet'],
    ['arriere_gauche_thenar', 'Thénar'],
    ['arriere_gauche_paume', 'Paume'],
    ['arriere_gauche_phalange_pouce_proximale', 'Pouce 1ere phalange'],
    ['arriere_gauche_phalange_pouce_distale', 'Pouce 2eme phalange'],
    ['arriere_gauche_articulation_pouce_interne', 'Pouce articulation MCP'],
    ['arriere_gauche_articulation_pouce_externe', 'Pouce articulation IP'],
    ['arriere_gauche_phalange_index_proximale', 'Index 1ere phalange'],
    ['arriere_gauche_phalange_index_mediane', 'Index 2eme phalange'],
    ['arriere_gauche_phalange_index_distale', 'Index 3eme phalange'],
    ['arriere_gauche_articulation_index_interne', 'Index articulation MCP'],
    ['arriere_gauche_articulation_index_mediane', 'Index articulation PIP'],
    ['arriere_gauche_articulation_index_externe', 'Index articulation DIP'],
    ['arriere_gauche_phalange_majeur_proximale', 'Majeur 1ere phalange'],
    ['arriere_gauche_phalange_majeur_mediane', 'Majeur 2eme phalange'],
    ['arriere_gauche_phalange_majeur_distale', 'Majeur 3eme phalange'],
    ['arriere_gauche_articulation_majeur_interne', 'Majeur articulation MCP'],
    ['arriere_gauche_articulation_majeur_mediane', 'Majeur articulation PIP'],
    ['arriere_gauche_articulation_majeur_externe', 'Majeur articulation DIP'],
    ['arriere_gauche_phalange_annulaire_proximale', 'Annulaire 1ere phalange'],
    ['arriere_gauche_phalange_annulaire_mediane', 'Annulaire 2eme phalange'],
    ['arriere_gauche_phalange_annulaire_distale', 'Annulaire 3eme phalange'],
    ['arriere_gauche_articulation_annulaire_interne', 'Annulaire articulation MCP'],
    ['arriere_gauche_articulation_annulaire_mediane', 'Annulaire articulation PIP'],
    ['arriere_gauche_articulation_annulaire_externe', 'Annulaire articulation DIP'],
    ['arriere_gauche_phalange_auriculaire_proximale', 'Auriculaire 1ere phalange'],
    ['arriere_gauche_phalange_auriculaire_mediane', 'Auriculaire 2eme phalange'],
    ['arriere_gauche_phalange_auriculaire_distale', 'Auriculaire 3eme phalange'],
    ['arriere_gauche_articulation_auriculaire_interne', 'Auriculaire articulation MCP'],
    ['arriere_gauche_articulation_auriculaire_mediane', 'Auriculaire articulation PIP'],
    ['arriere_gauche_articulation_auriculaire_externe', 'Auriculaire articulation DIP'],
];
exports.TEXTIFY_FRONT_FOOT_RIGHT = [
    ['avant_droit_cheville', 'Chevile'],
    ['avant_droit_os', 'Cunéiforme'],
    ['avant_droit_avant_interne', 'Avant pied interne'],
    ['avant_droit_avant_externe', 'Avant pied externe'],
    ['avant_droit_arriere_externe', 'Arrière pied externe'],
    ['avant_droit_arriere_interne', 'Arrière pied interne'],
    ['avant_droit_ongle_hallux', '1er orteil ongle'],
    ['avant_droit_articulation_hallux_externe', '1er orteil articulation IPD'],
    ['avant_droit_articulation_hallux_interne', '1er orteil articulation IPP'],
    ['avant_droit_phalange_hallux_distale', '1er orteil phalange distale'],
    ['avant_droit_phalange_hallux_proximale', '1er orteil phalange proximale'],
    ['avant_droit_ongle_secundus', '2eme orteil ongle'],
    ['avant_droit_articulation_secundus_externe', '2eme orteil articulation IPD'],
    ['avant_droit_articulation_secundus_interne', '2eme orteil articulation IPP'],
    ['avant_droit_phalange_secundus_distale', '2eme orteil phalange distale'],
    ['avant_droit_phalange_secundus_proximale', '2eme orteil phalange proximale'],
    ['avant_droit_ongle_tertius', '3eme orteil ongle'],
    ['avant_droit_articulation_tertius_externe', '3eme orteil articulation IPD'],
    ['avant_droit_articulation_tertius_interne', '3eme orteil articulation IPP'],
    ['avant_droit_phalange_tertius_distale', '3eme orteil phalange distale'],
    ['avant_droit_phalange_tertius_proximale', '3eme orteil phalange proximale'],
    ['avant_droit_ongle_quartus', '4eme orteil ongle'],
    ['avant_droit_articulation_quartus_externe', '4eme orteil articulation IPD'],
    ['avant_droit_articulation_quartus_interne', '4eme orteil articulation IPP'],
    ['avant_droit_phalange_quartus_distale', '4eme orteil phalange distale'],
    ['avant_droit_phalange_quartus_proximale', '4eme orteil phalange proximale'],
    ['avant_droit_ongle_quintus', '5eme orteil ongle'],
    ['avant_droit_articulation_quintus_interne', '5eme orteil articulation IPP'],
    ['avant_droit_phalange_quintus_proximale', '5eme orteil phalange'],
];
exports.TEXTIFY_FRONT_FOOT_LEFT = [
    ['avant_gauche_cheville', 'Chevile'],
    ['avant_gauche_os', 'Cunéiforme'],
    ['avant_gauche_avant_interne', 'Avant pied interne'],
    ['avant_gauche_avant_externe', 'Avant pied externe'],
    ['avant_gauche_arriere_externe', 'Arrière pied externe'],
    ['avant_gauche_arriere_interne', 'Arrière pied interne'],
    ['avant_gauche_ongle_hallux', '1er orteil ongle'],
    ['avant_gauche_articulation_hallux_externe', '1er orteil articulation IPD'],
    ['avant_gauche_articulation_hallux_interne', '1er orteil articulation IPP'],
    ['avant_gauche_phalange_hallux_distale', '1er orteil phalange distale'],
    ['avant_gauche_phalange_hallux_proximale', '1er orteil phalange proximale'],
    ['avant_gauche_ongle_secundus', '2eme orteil ongle'],
    ['avant_gauche_articulation_secundus_externe', '2eme orteil articulation IPD'],
    ['avant_gauche_articulation_secundus_interne', '2eme orteil articulation IPP'],
    ['avant_gauche_phalange_secundus_distale', '2eme orteil phalange distale'],
    ['avant_gauche_phalange_secundus_proximale', '2eme orteil phalange proximale'],
    ['avant_gauche_ongle_tertius', '3eme orteil ongle'],
    ['avant_gauche_articulation_tertius_externe', '3eme orteil articulation IPD'],
    ['avant_gauche_articulation_tertius_interne', '3eme orteil articulation IPP'],
    ['avant_gauche_phalange_tertius_distale', '3eme orteil phalange distale'],
    ['avant_gauche_phalange_tertius_proximale', '3eme orteil phalange proximale'],
    ['avant_gauche_ongle_quartus', '4eme orteil ongle'],
    ['avant_gauche_articulation_quartus_externe', '4eme orteil articulation IPD'],
    ['avant_gauche_articulation_quartus_interne', '4eme orteil articulation IPP'],
    ['avant_gauche_phalange_quartus_distale', '4eme orteil phalange distale'],
    ['avant_gauche_phalange_quartus_proximale', '4eme orteil phalange proximale'],
    ['avant_gauche_ongle_quintus', '5eme orteil ongle'],
    ['avant_gauche_articulation_quintus_interne', '5eme orteil articulation IPP'],
    ['avant_gauche_phalange_quintus_proximale', '5eme orteil phalange'],
];
exports.TEXTIFY_BACK_FOOT_RIGHT = [
    ['arriere_droit_talon_externe', 'Talon externe'],
    ['arriere_droit_talon_interne', 'Talon interne'],
    ['arriere_droit_medio_interne', 'Medio interne'],
    ['arriere_droit_medio_externe', 'Medio externe'],
    ['arriere_droit_plante_rond', 'Plante pulpe'],
    ['arriere_droit_plante_externe', 'Plante externe'],
    ['arriere_droit_plante_interne', 'Plante interne'],
    ['arriere_droit_articulation_hallux_externe', '1er orteil articulation IPD'],
    ['arriere_droit_articulation_hallux_interne', '1er orteil articulation IPP'],
    ['arriere_droit_phalange_hallux_distale', '1er orteil 2eme phalange'],
    ['arriere_droit_phalange_hallux_proximale', '1er orteil 1ere phalange'],
    ['arriere_droit_articulation_secundus_externe', '2eme orteil articulation IPD'],
    ['arriere_droit_articulation_secundus_interne', '2eme orteil articulation IPP'],
    ['arriere_droit_phalange_secundus_distale', '2eme orteil 2eme phalange'],
    ['arriere_droit_phalange_secondus_proximale', '2eme orteil 1ere phalange'],
    ['arriere_droit_articulation_tertius_externe', '3eme orteil articulation IPD'],
    ['arriere_droit_articulation_tertius_interne', '3eme orteil articulation IPP'],
    ['arriere_droit_phalange_tertius_distale', '3eme orteil 2eme phalange'],
    ['arriere_droit_phalange_tertius_proximale', '3eme orteil 1ere phalange'],
    ['arriere_droit_articulation_quartus_externe', '4eme orteil articulation IPD'],
    ['arriere_droit_articulation_quartus_interne', '4eme orteil articulation IPP'],
    ['arriere_droit_phalange_quartus_distale', '4eme orteil 2eme phalange'],
    ['arriere_droit_phalange_quartus_proximale', '4eme orteil 1ere phalange'],
    ['arriere_droit_articulation_quintus_interne', '5eme orteil articulation IPP'],
    ['arriere_droit_phalange_quintus_distale', '5eme orteil phalange'],
];
exports.TEXTIFY_BACK_FOOT_LEFT = [
    ['arriere_gauche_talon_externe', 'Talon externe'],
    ['arriere_gauche_talon_interne', 'Talon interne'],
    ['arriere_gauche_medio_interne', 'Medio interne'],
    ['arriere_gauche_medio_externe', 'Medio externe'],
    ['arriere_gauche_plante_rond', 'Plante pulpe'],
    ['arriere_gauche_plante_externe', 'Plante externe'],
    ['arriere_gauche_plante_interne', 'Plante interne'],
    ['arriere_gauche_articulation_hallux_externe', '1er orteil articulation IPD'],
    ['arriere_gauche_articulation_hallux_interne', '1er orteil articulation IPP'],
    ['arriere_gauche_phalange_hallux_distale', '1er orteil 2eme phalange'],
    ['arriere_gauche_phalange_hallux_proximale', '1er orteil 1ere phalange'],
    ['arriere_gauche_articulation_secundus_externe', '2eme orteil articulation IPD'],
    ['arriere_gauche_articulation_secundus_interne', '2eme orteil articulation IPP'],
    ['arriere_gauche_phalange_secundus_distale', '2eme orteil 2eme phalange'],
    ['arriere_gauche_phalange_secondus_proximale', '2eme orteil 1ere phalange'],
    ['arriere_gauche_articulation_tertius_externe', '3eme orteil articulation IPD'],
    ['arriere_gauche_articulation_tertius_interne', '3eme orteil articulation IPP'],
    ['arriere_gauche_phalange_tertius_distale', '3eme orteil 2eme phalange'],
    ['arriere_gauche_phalange_tertius_proximale', '3eme orteil 1ere phalange'],
    ['arriere_gauche_articulation_quartus_externe', '4eme orteil articulation IPD'],
    ['arriere_gauche_articulation_quartus_interne', '4eme orteil articulation IPP'],
    ['arriere_gauche_phalange_quartus_distale', '4eme orteil 2eme phalange'],
    ['arriere_gauche_phalange_quartus_proximale', '4eme orteil 1ere phalange'],
    ['arriere_gauche_articulation_quintus_interne', '5eme orteil articulation IPP'],
    ['arriere_gauche_phalange_quintus_distale', '5eme orteil phalange'],
];
exports.TEXTIFY_FRONT_HEAD = [
    ['avant_front_milieu', 'Front milieu'],
    ['avant_front_gauche', 'Front gauche'],
    ['avant_front_droit', 'Front droit'],
    ['avant_entre_sourcils', 'Entre sourcils'],
    ['avant_arcade_gauche', 'Arcade gauche'],
    ['avant_arcade_droit', 'Arcade droite'],
    ['avant_orbite_droit', 'Orbite droite'],
    ['avant_orbite_gauche', 'Orbite gauche'],
    ['avant_zone_nez', 'Zone du nez'],
    ['avant_pommette_gauche', 'Pommette gauche'],
    ['avant_pommette_droit', 'Pommette droite'],
    ['avant_joue_gauche', 'Joue gauche'],
    ['avant_joue_droit', 'Joue droite'],
    ['avant_menton', 'Menton'],
    ['avant_entre_yeux', 'Entre yeux'],
    ['avant_cou_milieu', 'Cou milieu'],
    ['avant_cou_droit', 'Cou droit'],
    ['avant_cou_gauche', 'Cou gauche'],
    ['avant_oreille_gauche', 'Oreille gauche'],
    ['avant_oreille_droit', 'Oreille droite'],
    ['avant_zone_bouche', 'Zone bouche'],
    ['bouche_langue', 'Langue'],
    ['bouche_palais', 'Palais'],
    ['bouche_dents_bas', 'Dents bas'],
    ['bouche_levres_inferieures', 'Lèvre inférieure'],
    ['bouche_dents_haut', 'Dents haut'],
    ['bouche_levres_superieures', 'Lèvre supérieure'],
    ['bouche_gencive_haut', 'Gencive haut'],
];
exports.MANNEQUIN_COLORS = [
    ['section', '#3E2DD7', 'Section'],
    ['brulure', '#ffc435', 'Brûlure'],
    ['plaie', '#fd5252', 'Plaie'],
    ['deformation', '#68DA18', 'Déformation'],
    ['trauma', '#d2691e', 'Trauma'],
    ['gonflement', '#B72DCD', 'Gonflement'],
    ['douleur', '#FEED01', 'Douleur'],
    ['hemorragie', '#01e9fe', 'Hémorragie'],
    ['fracture', '#006720', 'Fracture'],
    ['contusion', '#f18bff', 'Contusion'],
];
exports.MANNEQUIN_VISIBLE_COLORS = new Map([
    [-1, 'CombinaisonInconnue'],
    [0, 'Vide'],
    [1, 'Section'],
    [2, 'Brulure'],
    [4, 'Plaie'],
    [8, 'Deformation'],
    [16, 'Trauma'],
    [32, 'Gonflement'],
    [64, 'Douleur'],
    [66, 'BrulureDouleur'],
    [10, 'BrulureDeformation'],
    [34, 'BrulureGonflement'],
    [6, 'BrulurePlaie'],
    [3, 'BrulureSection'],
    [18, 'BrulureTrauma'],
    [72, 'DouleurDeformation'],
    [96, 'DouleurGonflement'],
    [68, 'DouleurPlaie'],
    [65, 'DouleurSection'],
    [80, 'DouleurTrauma'],
    [40, 'DeformationGonflement'],
    [12, 'DeformationPlaie'],
    [9, 'DeformationSection'],
    [24, 'DeformationTrauma'],
    [36, 'GonflementPlaie'],
    [33, 'GonflementSection'],
    [48, 'GonflementTrauma'],
    [5, 'PlaieSection'],
    [20, 'PlaieTrauma'],
    [17, 'SectionTrauma'],
    [74, 'BrulureDouleurDeformation'],
    [98, 'BrulureDouleurGonflemement'],
    [70, 'BrulureDouleurPlaie'],
    [67, 'BrulureDouleurSection'],
    [82, 'BrulureDouleurTrauma'],
    [42, 'BrulureDeformationGonflement'],
    [14, 'BrulureDeformationPlaie'],
    [11, 'BrulureDeformationSection'],
    [26, 'BrulureDeformationTrauma'],
    [38, 'BrulureGonflementPlaie'],
    [35, 'BrulureGonflementSection'],
    [50, 'BrulureGonflementTrauma'],
    [7, 'BrulurePlaieSection'],
    [22, 'BrulurePlaieTrauma'],
    [19, 'BrulureSectionTrauma'],
    [104, 'DouleurDeformationGonflement'],
    [76, 'DouleurDeformationPlaie'],
    [73, 'DouleurDeformationSection'],
    [88, 'DouleurDeformationTrauma'],
    [100, 'DouleurGonflementPlaie'],
    [97, 'DouleurGonflementSection'],
    [112, 'DouleurGonflementTrauma'],
    [69, 'DouleurPlaieSection'],
    [84, 'DouleurPlaieTrauma'],
    [81, 'DouleurSectionTrauma'],
    [44, 'DeformationGonflementPlaie'],
    [41, 'DeformationGonflementSection'],
    [56, 'DeformationGonflementTrauma'],
    [13, 'DeformationPlaieSection'],
    [28, 'DeformationPlaieTrauma'],
    [25, 'DeformationSectionTrauma'],
    [37, 'GonflementPlaieSection'],
    [52, 'GonflementPlaieTrauma'],
    [49, 'GonflementSectionTrauma'],
    [21, 'PlaieSectionTrauma'],
]);
exports.solutes = [
    'Sérum Phy',
    'Ringer Lactate',
    'Sérum salé hypertonique (SSH)',
    'Hydroxyle Ethyl Amidon (HEA)',
    'Gélatine',
    'Glucosé 5%',
    'Glucosé 10%',
];
exports.solutesSdis38 = [
    'G30% sol unidose',
    'G5 % sol flacon',
    'H.E.A sol poche',
    'Sérum phy sol poche',
    'Ringer Lactate sol flacon',
];
exports.PRESCRIPTION_STATE_LABEL = new Map([
    ['IN_PROGRESS', (isMed, bilan) => (bilan.en_cours === 'no' ? isMed ? 'Non administrée' : 'Non réalisée' : 'En attente')],
    ['REFUSED', (isMed, bilan) => 'Irréalisable'],
    ['CANCELED', (isMed, bilan) => 'Annulée'],
    ['COMPLETED', (isMed, bilan) => isMed ? 'Administrée' : 'Réalisée'],
]);
/**
 * NE PAS CHANGER LES UUIDS
 */
exports.UUID_OPTIONS = new Map([
    ['15ca14fb-09f1-4724-b4b7-f3e49772a939', 'Bilan jaune'],
    ['6fb2efcf-40cd-472a-8eb4-7c4383274977', 'Bilan blanc'],
    ['454b6bb0-bcc6-4dad-b589-94e142dfd46e', 'Bilan rouge'],
    ['260ace70-a31e-4e9e-8d19-f9f9f4be43c1', 'Bilan vert'],
    ['55381c51-8ea2-4af6-b48e-5df06de0f30d', 'Impliqué'],
    ['56d2158c-a0e1-4390-964d-7855d987e926', 'Urgence relative'],
    ['1ce9c186-8531-43e7-972b-4c395c996932', 'Urgence absolue'],
    ['d7560b43-9615-4558-9ea0-23ac63740143', 'Décédé'],
    ['682e4e1d-9103-4fb7-b1d7-c0ebca25acc0', 'VSAV'],
    ['71aaee21-b814-48e5-a5cd-44ce0614c0fd', 'SMUR'],
    ['306ef76e-6b5a-4831-948a-748714677aed', 'Hélicoptère'],
    ['765b131b-4b15-45e9-8192-5977a4796424', 'Propre moyen'],
    ['568c1e35-0fee-44d2-a3ee-9d1814e24ff5', 'AP'],
    ['1430deaf-6729-44d5-aba8-cba1f11967d2', 'Police'],
    ['9fa62913-25b6-4268-9928-8242a1d7388a', 'Gendarmerie'],
    ['4a41d74f-7b2f-4de0-82b8-5d29de1306e0', 'VSAV - SMUR'],
    ['fcd91f22-b01e-4d54-96a2-90a2cfb088cc', 'VSAV - VSM'],
    ['fd021848-1046-4e74-a41a-be59fa886a9a', 'AP - VSM'],
    ['7b4c6ffa-ca1e-4438-b493-757d3cd44db0', 'Sortie blanche'],
    ['2b21c514-69f4-4795-b7e6-e288b3bac3db', 'Transporté'],
    ['856c7d31-caed-4881-a6a4-d0689a8d09f0', 'Transport non médicalisé'],
    ['03bfc0b6-403b-4e7e-8fd0-1e6efc07c968', 'Transport paramédicalisé'],
    ['0e5a82ac-dbc3-4ba0-b949-4677fa4c2a1a', 'Transport médicalisé'],
    ['7da8a677-581c-4d8c-ac25-07466cfe7c9f', 'Laissé sur place'],
    ['1ba0ab1d-673d-4137-93be-b81b61d23470', 'Refus de soins'],
    ['992406e7-307b-4b7b-a43c-547d40076a08', 'Refus de transport'],
    ['9b9e4e04-6501-488d-94dc-22e55f49d862', 'Soins sur place'],
    ['ff6accc7-5c61-48b5-a348-97502153cbdb', 'Non blessé'],
    ['593c05e8-15bd-4290-8170-cf18ea00dc25', 'Décédé avec réanimation'],
    ['4c238698-0a39-4787-bc8d-165f25ed5fb1', 'Décédé sans réanimation'],
    ['30ab83ce-5115-450a-9d8c-b74f96d345b2', 'Certificat de décés avec obstacle'],
    ['aea5d787-184d-4448-8920-e95ca1b939eb', 'Certificat de décés sans obstacle'],
    ['48ea8d7a-b625-4bf8-b705-bd9881e88fa3', 'Procédure SDIS - SAMU'],
    ['3bf25da9-9e9e-4dc7-a73a-1fe48153b634', 'Transport non paramédicalisé'],
    ['c4df2762-06d7-4f13-b131-ab987504804f', 'Transport sur réquisition'],
    ['9d289b2d-f103-4faa-88f6-c2a1ee27874a', 'Relais ambulancier'],
    ['bc2e1d76-0973-4f8d-ad3c-c40fe3f47d94', 'Relais hélicoptère'],
    ['7e8896aa-29b5-492e-b862-f2a03736fccf', 'Relais SMUR'],
    ['62a0714e-f267-4162-8615-a96b7a612fc7', 'jours'],
    ['e0bc04c5-a9e4-4f4f-9d9f-523162347ff9', 'mois'],
    ['2413bfd8-bc20-48e4-b425-e1307e1fd2b3', 'ans'],
    ['e10e2878-2205-410f-90c5-b09e98953d9f', 'Homme'],
    ['5ae0750f-0e32-4b07-8ab6-890b4f56cca0', 'Femme'],
    ['b84ff885-0299-4aff-8d76-1bfd5cba7725', 'Indéterminé'],
    ['ca620a32-47b0-45c3-84cb-cd198bbf6c59', 'Piste balisée ouverte'],
    ['4397e5dc-3f79-4e63-af4d-7a8787a24d4b', 'Piste balisée fermée'],
    ['1729bd0c-b25f-4b59-ba3c-899c0d2c4a6f', 'Front neige'],
    ['506db829-004b-45f6-ba69-05593ccfa7cf', 'Piste RM'],
    ['eedfebc2-f5cf-457e-b6c0-6c572f04647c', 'Promenade piétons'],
    ['d62d3925-2516-4d12-adca-3df07de47aa5', 'Embarquement débarquement RM'],
    ['64b38875-4588-4d44-abfc-de397af8b8ba', 'Hors piste à proximité'],
    ['ea615404-db4f-43ef-958e-4c810052e967', 'Hors piste'],
    ['073b2ce9-65aa-4236-83a0-a60dc3b6de56', 'Fond'],
    ['b47ee4f3-b9e6-4e3f-83bb-f3062e34873b', 'Autre'],
    ['8bca5812-d65f-465e-bd53-34368a6a886d', 'Oui sur les lieux'],
    ['d46420f0-d439-42ea-9ed5-d8c0de052160', 'Oui à distance'],
    ['62569b6e-180c-462c-94c5-67a132f49a67', 'Non'],
    ['527b4fc3-a3ef-49bd-ad37-2fa80dc29e59', 'Bosse'],
    ['c275cd79-d103-48da-95d5-ac6efa6d0c80', 'Rupture pente'],
    ['3ce7674b-5d45-4cf7-994f-3a19cd89ce7a', 'Courbe'],
    ['bba206af-da7d-4a99-909e-76bbd549b802', 'Cailloux'],
    ['7d93208f-ed65-4b16-bf2f-c149072f3325', 'Trou'],
    ['5aa7d06b-630a-49ce-93ea-5d9daf6a10e4', 'Obstacle'],
    ['4f33199a-acfb-4114-ad1e-0d1ae970264a', 'Personne'],
    ['d9d410b8-9567-4047-b683-d6152011a601', 'Tort blessé auteur'],
    ['92c6b523-1dab-4edf-b9c9-2d524623acbb', 'Tort blessé victime'],
    ['54dea163-dd32-469b-9444-1d3850cd8e40', 'Torts partagés'],
    ['72255ad3-6c57-44c1-8346-24daa83ce1ef', 'Pylone'],
    ['d69d2e42-f430-4e5c-adba-d43bdfc84e8c', 'Jalon balise'],
    ['98c99c53-dfa6-45f4-8b46-6fa1ec067869', 'Rocher'],
    ['e9abde0a-4dac-46f5-b63a-f669dedb983b', 'Arbre'],
    ['50f0890f-5df6-4156-be84-1a9c46e1dd8f', 'Filer corde'],
    ['bb5b8510-749d-4b6a-a82d-57e37945d6d9', 'Véhicule neige'],
    ['8b0347ca-846f-47dc-85e5-3d953769a415', 'Corde'],
    ['6280ffa5-4697-4808-b277-1c9cdaf24a8d', 'Filet'],
    ['d493bcab-e3f9-495e-a573-d589ce743603', 'Jalon'],
    ['fff9c640-8115-48a1-a4e1-b768550085c6', 'Panneau'],
    ['3c758c06-4729-49d9-8ab1-524ef5d4d725', 'Matela'],
    ['ba41896f-b049-4457-8fe2-7cae24dd55df', 'Paille'],
    ['7f7249db-6dac-495a-bf8b-1a660fdadf01', 'Ski'],
    ['566f53ca-16bb-476a-8ade-d4727e86be62', 'Surf'],
    ['c387bbd3-c78e-438d-9e57-1a7129f1cba0', 'Monoski'],
    ['12905853-7942-4aec-a366-a5463da7103a', 'Luge'],
    ['d9a763ca-199a-426e-9910-a432988f40f3', 'Piéton'],
    ['79ca6f30-4e96-4859-99f6-ee71fac460f2', 'Débutant'],
    ['ef499aa1-9a6a-4b38-8488-23fbd52c2924', 'Initié'],
    ['f734416e-f56a-4147-a73e-c16e02e8cd67', 'Bon'],
    ['f152e780-cbcf-4935-b66c-a33522fed9d6', 'Inconnu'],
    ['763edd01-8651-4083-a56c-31e48cebe6be', 'Arrêt'],
    ['90bec947-dec8-49ef-ad4c-95378c0ae493', 'Lente'],
    ['17a36816-c2b2-45e0-8562-5d2cf0f1eaa6', 'Moyenne'],
    ['49732934-6763-4c37-bbf0-62e973e93808', 'Élevée'],
    ['a1149584-802a-4c86-96bb-a9a5bfa8dbbb', 'Non critique'],
    ['0c5b6ded-7b0f-49d3-9d6a-b7f128ec6566', 'Critique'],
    ['45ec04b2-2c8f-4369-8fe3-4980c4bd71f1', 'Etat de mort évident'],
    ['4a46894c-87e0-457d-9bf6-7e5faf5e40c2', 'Indemne'],
    ['d2831dfb-9732-434f-b000-929e7f87858c', 'BL'],
    ['60702a22-a964-4623-93b9-bc6b400b43dc', 'BG'],
    ['62f716bc-9ed3-423b-a30e-b758b62a142c', 'DCD'],
    ['e163ceb6-2dfd-4e24-adc3-c4ad0b75e36a', 'ASSU'],
    ['efafd1f9-8c4c-422d-aacb-90c31d491274', 'VTP'],
    ['c2f20450-be92-4131-8bed-4130b5ae58c6', 'Train'],
    ['b88cca64-5aef-4957-9aa7-a46cfe1a802b', 'VSM'],
    ['b7c861f7-3abb-4a41-bd84-32d21372fd0c', 'Bateau'],
    ['4200e28f-bca4-4b0a-b487-bbd4fe189cca', 'ASC'],
    ['97b1cdf6-79bd-4932-87fb-444a228e8aa7', 'Autre vecteur SDIS'],
    ['1a121bdd-0366-46d6-8c8a-0997280c842f', 'Transport domicile'],
    ['66750f5f-2062-45c1-b4e0-16c47da7fbe8', 'Personne non bléssée'],
    ['561514a9-0f63-4691-a067-6818f98cbf3a', 'Renfort DSM'],
    ['dcdc0639-d698-4715-9ca8-4a7a95bf34ec', 'Renfort SMUR'],
    ['14082ff6-d33e-48b1-ad9f-5baa98723ad2', 'Renfort médical autre'],
    ['d2cac2ee-42a8-4680-8846-0e555e2ee7e0', "Prise en charge par les forces de l'ordre"],
    ['3f05296c-77f0-4a69-893c-bd269511194f', 'Avec arrêt de la réanimation par régulation SAMU'],
    ['9f538dee-de16-4414-adb6-0e0d96abb215', 'mg'],
    ['15146c79-c8fb-4644-8a9b-1f6f7cdc41bd', 'g'],
    ['023a07d8-3d14-4ee5-9759-5bd2fc89e804', 'mL'],
    ['96b1b561-a3e2-4440-a8c7-4e2039de9602', 'L/min'],
    ['945c657a-92fd-47c6-834c-100f6851e5c9', 'mg/h'],
    ['32c666c4-7d7d-444f-8a39-ece58b1d9ad0', 'Dose(s)'],
    ['d508f1bf-ad29-49de-ae2e-9f6df5eeaf9d', 'Sachet(s)'],
    ['135d1a56-da66-4f4c-9851-81daf5ff77de', 'Comprimé(s)'],
    ['cb99df2f-5420-429d-962e-fcc5c4ab6993', 'Ampoule(s)'],
    ['54a45b84-36e3-45b7-9718-e4bc165e00c9', 'Suppositoire(s)'],
    ['18cf7571-69ae-4497-9f8f-70be86fd232e', 'gamma/kg/min'],
    ['4a39ef0b-c1bc-4424-adf4-0dadb2c454cb', 'UI'],
    ['d43b6f12-98fa-425d-9f8d-d999e79fbb9d', 'µg/h'],
    ['62bb2601-43c6-44a4-a915-f0107777a419', 'UI/h'],
    ['8eb57158-8987-4380-88b3-31306ecac0a7', 'µg'],
    ['6b426ead-4c47-4ac2-ac87-d398ad045b42', 'Téléassistance'],
    ['e55e2162-566b-46c3-918a-b6c7b9a8e1e1', 'Aidant familial'],
    ['f95a1aca-b4bb-4b52-9526-6527a664ba1b', 'Aidant professionnel'],
    ['92a90fce-d872-43a7-8c49-8cb2a5f272e8', 'Personne elle même'],
    ['e6ecbbf4-7333-4e66-9c78-faa8e9501b45', 'Récidive chutes'],
    ['e9da41b1-453f-4bf2-b84a-2d06383514d6', 'Logement insalubre'],
    ['264bdc19-e9a4-4072-96c0-f0bd7df9f7cc', 'Logement inadapté'],
    ['5f8c3126-d861-4e8e-96aa-832a997fe2f6', 'Perte autonomie'],
    ['c4b51c7a-be73-48ee-9ecb-341e4065be67', 'Violence abus de faiblesse'],
    ['fce9db44-6d9c-438c-8c75-3f91ee4d9518', 'Détresse psy'],
    ['6e50804d-85a8-42f3-a7b9-21fb7c182f06', 'Manque hygiène'],
    ['6f20f628-0f2d-4aa9-a0c0-e47355f6f7e9', 'Difficulté soins/alimentation'],
    ['2633aa3d-c260-4d49-bf50-37cad81042c0', 'Interventìon multiples'],
    ['dffc42d3-7381-472f-a7a9-3f84fd0a2a6f', 'Oui'],
    ['8449126e-4870-4487-8f6b-4bb6c4a232dd', 'Ne sais pas'],
    ['55a513b4-e12d-4307-a8e3-4f281a21734b', 'Relevage'],
    ['70c9b8e4-5019-4010-8146-2769c8f473e1', 'Problématique sociale'],
    ['824cdf65-66ef-4d72-a31c-3c245cf14645', 'Affection médicale'],
    ['c482ed70-65a8-49ec-83d7-e91d5c7fff4a', 'Malaise'],
    ['545d5172-b26f-430b-869b-878e8a8e0c63', 'Intoxication alimentaire'],
    ['b5874863-acff-492f-9622-2ba7517d1f67', 'Intoxication fumée'],
    ['cf9091bb-5895-43df-88ce-25cc64ce1b6a', 'Intoxication CO'],
    ['953b185a-f8a9-48f5-ae4e-9a957b1b8c61', 'Intoxication OH'],
    ['21aae365-16a6-4dcc-a9e2-d48810aae54a', 'Intoxication médicamenteuse'],
    ['75accb1d-15c4-4f79-982d-3c2b52d626a0', 'Intoxication stupéfiants'],
    ['d97690a0-7803-4706-bce1-6facc1b22f54', 'Trouble du comportement'],
    ['9ab8f365-028d-4c6e-aa14-455e67c80f23', 'Femme en couche'],
    ['0eb72177-f20f-43fe-8bd3-86b169261bf7', 'Traumatisme'],
    ['714cf3fa-73db-43e1-ba4a-53006ee5c4f9', 'Chute inf à 1,5x la taille de la victime'],
    ['d72c8617-7298-45d7-9476-827c11799cbf', 'Chute sup à 1,5x la taille de la victime'],
    ['716a54d5-fa16-4f6d-9add-6d619d6ccf7a', 'Plaie non grave'],
    ['b06bed05-6129-4ba9-991d-73af86c9efb1', 'Plaie grave'],
    ['e0f6548f-7690-4b35-b2c9-6eb5967e6e27', 'Plaie par arme à feu'],
    ['e77ca958-3723-488f-b86a-3d29cf6901de', 'Plaie par arme blanche'],
    ['c170fffb-e31f-4c18-bb28-7b81f2ff14a4', 'Brûlure non grave'],
    ['583a67c6-7afe-4cd5-a572-410fface8836', 'Brûlure grave'],
    ['a6ece2a6-3cfd-49d1-90d0-1976ed78967e', 'Déformation cuisse'],
    ['7386f808-88d1-486e-988a-feb477ab859b', 'Pendaison'],
    ['8abba108-5a5f-4adc-89a6-3ab9a1ec8830', 'Noyade'],
    ['38769331-3c19-4a0c-901c-6f559af4b985', 'Accident de plongée'],
    ['339fb82e-92e9-4b07-9a52-a1efd6e4f702', 'Explosion / incendie'],
    ['f9aeb310-5179-4e57-8f13-9799e0e8ffea', 'Agression / rixe'],
    ['46c084d6-13ea-4f21-ba28-15dedb53a55f', 'Mise à disposition de moyens privés ou publics'],
    ['83b2e447-5033-4b78-84e1-5da22c2376cc', 'Réquisitions de moyens privés'],
    ['0ff53d29-6957-4d69-ba25-9bd54205f6d1', 'Utilisation de la caméra piéton'],
    ['e16b1072-97d1-44ad-ad12-2b0953dba0bc', 'Maire ou son représentant'],
    ['f4845765-ccf6-4f5a-9fdd-dce00eabdb76', 'Préfet ou son représentant'],
    ['6beddc43-7491-4a37-960f-724867d74c1a', 'Pompes funèbres'],
    ['9f19b0bf-7884-418f-bfb8-50b962dd420b', 'Centre de traitement des appels'],
    ['79016dc2-72e3-455d-8f9f-c589900398d9', 'Centre d\'incendie et de secours'],
    ['6076e8c5-a99b-42cf-87ea-d4ea5b3529e4', 'Evènement climatique'],
    ['c80dcfed-094d-4178-884b-f1d55b6bff5f', 'Evènement industriel ou technologique'],
    ['f88c3055-9479-49ca-ab9c-330d3c0006a8', 'Accident de la circulation'],
    ['b262115f-24bd-434b-8e50-9c03bc6c24eb', 'Origine fortuite'],
    ['85071a6b-67b5-4451-8cf1-d78fc0b4ed69', 'Evenement naturel'],
    ['4bfba75b-bb49-4315-9c55-913fd59ef5cc', 'Evenement malveillant'],
    ['0bd59ea0-d544-4dcd-8365-0004c5ba04a3', 'Tentative de suicide / Suicide'],
    ['d1c8a9fc-7567-4217-8f65-8e198a537fe3', 'Agglomération'],
    ['2cfa37dd-1c9c-4bfc-a1ad-a794cda69386', 'Route départementale'],
    ['ac0d9c36-48e7-42dc-add1-7607844fbdf0', 'Route nationale'],
    ['07b1b972-6059-46aa-8b0b-e314f69ff582', 'Autoroute'],
    ['b1f8cca3-5790-4fe1-bbae-558d39d7446d', 'Route à grande circulation'],
    ['00000000-0000-0000-0000-000000000001', 'Accident en milieu périlleux'],
    ['00000000-0000-0000-0000-000000000002', 'Accident de plongée'],
    ['00000000-0000-0000-0000-000000000003', 'Accident aérien'],
    ['00000000-0000-0000-0000-000000000004', 'Électrisation'],
    ['00000000-0000-0000-0000-000000000005', 'Explosion blast'],
    ['00000000-0000-0000-0000-000000000006', 'Syndrome de compression'],
    ['00000000-0000-0000-0000-000000000007', 'Trouble du comportement agressivité'],
    ['00000000-0000-0000-0000-000000000008', 'Agitation psychomotrice'],
    ['00000000-0000-0000-0000-000000000009', 'État délirant'],
    ['00000000-0000-0000-0000-000000000010', 'Tetanie spasmophilie'],
    ['00000000-0000-0000-0000-000000000011', 'Agression sexuelle'],
    ['00000000-0000-0000-0000-000000000012', 'Suicide'],
    ['00000000-0000-0000-0000-000000000013', 'Pendaison strangulation'],
    ['00000000-0000-0000-0000-000000000014', 'Porte intérieure'],
    ['00000000-0000-0000-0000-000000000015', 'Porte paliere'],
    ['00000000-0000-0000-0000-000000000016', 'Volet'],
    ['00000000-0000-0000-0000-000000000017', 'Fenêtre'],
    ['00000000-0000-0000-0000-000000000018', 'Barrière'],
    ['00000000-0000-0000-0000-000000000019', 'Placard technique'],
    ['00000000-0000-0000-0000-000000000020', 'Antenne'],
    ['00000000-0000-0000-0000-000000000021', 'Elément technique'],
    ['00000000-0000-0000-0000-000000000022', 'Store'],
    ['00000000-0000-0000-0000-000000000023', 'Porte fenêtre'],
    ['00000000-0000-0000-0000-000000000024', 'Portillon'],
    ['00000000-0000-0000-0000-000000000025', 'Cheminée'],
    ['00000000-0000-0000-0000-000000000026', 'Élement toiture'],
    ['e38a5936-972f-4832-b043-87b5691e8284', 'Principal'],
    ['20583a08-68cd-4b82-9027-69705df8fa7c', 'Secondaire'],
    ['ed3b81ea-9d67-4037-800c-a66091067684', 'Opération conventionnée'],
    ['475a87b2-7092-494f-ad4e-336f6df14dc6', 'Opération à caractère payant'],
    ['00000000-0000-0000-0000-000000000027', 'Victime partie / introuvable'],
    ['00000000-0000-0000-0000-000000000028', 'Transportée par vecteur sapeur-pompier'],
    ['00000000-0000-0000-0000-000000000029', 'Transportée par vecteur autre que sapeur-pompier'],
    ['00000000-0000-0000-0000-000000000030', 'Réanimation'],
    ['00000000-0000-0000-0000-000000000031', 'Coronarographie'],
    ['00000000-0000-0000-0000-000000000032', 'Urgences'],
    ['00000000-0000-0000-0000-000000000033', 'Appareil'],
    ['00000000-0000-0000-0000-000000000034', 'Électrodes'],
    ['00000000-0000-0000-0000-000000000035', 'Appareil et Électrodes'],
]);
